import axios, { AxiosResponse } from "axios";
import defaultCoverImage from "../assets/images/small/img-4.jpg";
import { DO_NOT_USE_OR_YOU_WILL_BE_FIRED_EXPERIMENTAL_CREATE_ROOT_CONTAINERS } from 'react-dom/client';
import { UserStruct, UserTypes, UserRoles, UserTypeInfo, UserRoleInfo } from '../api/auth';

import { messaging } from "../../src/helpers/firebase-config";
import { getToken, deleteToken, onMessage } from "firebase/messaging";
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Badge } from '@capawesome/capacitor-badge';
import { Preferences } from '@capacitor/preferences';
import { v4 as uuidv4 } from 'uuid';
import { UAParser as UA } from 'ua-parser-js';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { MemberRole, TaskStatus, WpActionTypes, WpStatus } from '../redux/workplace/wpTypes';
import { apiOk, setActivePostId2, setDraftPost } from '../redux/workplace/wpActions';
import { APIClient } from 'api/apiCore';
import * as urls from "api/urls";
import { AppDispatch } from 'redux/store';
import { Const, FrontEndApp, RecuranceModes, SKeys } from "const";
import { TABS, WpModes, WpSortMode } from "../constants";
import {
  TaskFormFieldData, TaskRecuranceData, TaskRecurance2Data,/*TaskRecuranceDtlData*/
  HookEvents, HookFilterData
} from "types";
import { changeTab } from "../redux/actions";

declare function isNotificationPermissionGranted(): boolean;
declare function askForPushNotification(bSilent: boolean): Promise<string>;
declare function isPWAInstalled(): boolean;


// Define possible values for OS, browser, and device type
type DeviceOS = "Android" | "iOS" | "MacOS" | "Windows" | "Unknown OS";
type DeviceBrowser = "Firefox" | "Safari" | "Opera" | "Chrome" | "Edge" | "Unknown";
type DeviceType = "Mobile" | "PC";

// response shape of POST check-app-update-chatnative
export interface AppUpdateCheckResult {
  versioncode?: string;
  isuptodate?: boolean;
  forceupdate?: boolean;
  releasedatetime?: string;
  shortinfo?: string;
}

class LogDb {
  private source: string;
  private username: string;
  private count: number = 0;

  constructor(source?: string, username?: string) {
    this.source = source ?? Utils.GetUniqueId();
    this.username = username ?? "";
  }

  public Write(msg: string): void {
    this.count = this.count + 1;
    Utils.LogDb(msg, this.count, this.source, this.username);
  }
}

enum Conf_Keys {
  WorkPlaceTitle1Line = "cnf_wptl",
  WorkPlaceTitleShowLastChat = "cnf_wptslc",
  WorkPlaceRememberFilter = "cnf_wprmfltr",
  WorkPlaceFilterUnread = "cnf_wpfltr_unr",
  WorkPlaceFilterUnreadTk = "cnf_wpfltr_unrTk",
  WorkPlaceFilterNotYetClose = "cnf_wpfltr_nyc",
  WorkPlaceFilterNotYetCloseTk = "cnf_wpfltr_nyctk",
  WorkPlaceSort = "cnf_wpsort",
  WorkPlaceSortTk = "cnf_wpsorttk",
  WorkPlaceShareFilterWpTask = "cnf_wpsharefltr",
}


class Utils {
  //static MSG_CHAT_DISCONNECT = 'ระบบแชทถูกปิด กรุณา <a href="#" onclick="window.location.reload(); return false;">แสดงใหม่</a> หรือ <a href="/auth-login">ล็อกอิน</a> ใหม่';
  static MSG_CHAT_DISCONNECT = 'หลุดการเชื่อมต่อ กำลังเชื่อมต่อใหม่ หรือกด <a href="#" onclick="window.location.reload(); return false;">แสดงใหม่</a> เพื่อรีโหลด';//หรือ <a href="/auth-login">ล็อกอิน</a> ใหม่';
  static MSG_CHAT_CONNECTING = 'กำลังเชื่อมต่อระบบแชท <a href="#" onclick="window.location.reload(); return false;">แสดงใหม่</a>';
  static APP_VERSION = "?v=" + (process.env.REACT_APP_VERSION || "");

  // Single source for "what version is this" wherever it needs to be shown or sent -
  // native (Android/iOS) reads the real installed build via @capacitor/app's App.getInfo()
  // (Android versionName / iOS MARKETING_VERSION, whichever this binary was actually built
  // with - see the comment in .env for where those live), so it can't drift from what the
  // store actually shipped the way a manually-bumped env var can. PWA has no native binary to
  // read, so it keeps using REACT_APP_VERSION/.env - which is fine there, since PWA isn't part
  // of this update-check at all (it self-updates via the service worker).
  static async GetDisplayAppVersion(): Promise<string> {
    if (Capacitor.isNativePlatform()) {
      try {
        const info = await CapacitorApp.getInfo();
        return info.version;
      } catch (e) {
        console.error("GetDisplayAppVersion: App.getInfo() failed, falling back to .env version", e);
      }
    }
    return Utils.APP_VERSION.replaceAll("?v=", "");
  }


  private static tabs: { [key: string]: Window | null } = {};

  public static OpenUrlInSameTab(url: string, tabName: string): void {
    if (!this.tabs[tabName] || this.tabs[tabName]?.closed) {
      this.tabs[tabName] = window.open(url, tabName);
    } else {
      this.tabs[tabName]!.location.href = url;
      this.tabs[tabName]!.focus();
    }
  }

  public static IsUrlNeedExternalParsing(callFrom: string, url: string, extUserId: any, customerIsCdSys: any): boolean {
    console.log('get external url from: ', {callFrom, url, extUserId, customerIsCdSys});
    if (Utils.IsUrlIsStaticInsideChat(url)) {
      console.log("url is inside chat");
      return true;
    }

    if (!extUserId) {
      // console.log('extUserId = ' + extUserId);
      return false;
    }
    if (!customerIsCdSys) {
      console.log('customerIsCdSys = ' + customerIsCdSys);
      return false;
    }
    const linkUrl = new URL(url, window.location.href);
    const isInternal = linkUrl.origin === window.location.origin;
    if (isInternal) {
      console.log('link is internal');
      return false; // return origianl if given url is inside current domain
    }

    const is2sOnline = url.toLowerCase().includes('2sonline');
    // Any other 2smetal.com subdomain (or the bare domain) besides chat.2smetal.com itself -
    // e.g. sub.2smetal.com, 2smetal.com - should be treated the same as the 2sonline case.
    // Hostname-based (not a raw substring check on the whole URL) so a lookalike domain like
    // evil2smetal.com.attacker.net can't spoof this.
    const hostname = linkUrl.hostname.toLowerCase();
    const isOtherSmetalSubdomain = (hostname === '2smetal.com' || hostname.endsWith('.2smetal.com')) && hostname !== 'chat.2smetal.com';
    if (!is2sOnline && !isOtherSmetalSubdomain) {
      console.log('link is not 2sonline or another 2smetal.com subdomain');
      return false; // return original if given URL not on 2sonline or another 2smetal.com subdomain
    }

    return true;
  }



  public static IsUrlIsStaticInsideChat(url: string): boolean {
    // const backendUrl = process.env.REACT_APP_APIURL; // "https://chat.2smetal.com"
    // console.log('backendUrl = ' + backendUrl);
    const currentOrigin = window.location.origin;
    // console.log('currentOrigin = ' + currentOrigin);
    const url2 = url.toLowerCase();
    if (
      url2.startsWith("/_upload/")
      || url2.startsWith("/_uploadqck/")
      || url2.startsWith("/_uploadwp/")

      || url2.startsWith(currentOrigin + "/_upload/")
      || url2.startsWith(currentOrigin + "/_uploadqck/")
      || url2.startsWith(currentOrigin + "/_uploadwp/")
    ) {
      return true;
    } else {
      return false;
    }
  }

  public static ConvertUrlIfItIsInternalChat(url: string): string {
    try {
      if (Utils.IsUrlIsStaticInsideChat(url)) {
        const currentOrigin = window.location.origin;
        const targetOrigin = process.env.REACT_APP_URL_FOR_STATIC || "";

        // Normalize input URL
        const fullUrl = new URL(url, currentOrigin);

        // If same origin, strip it out and prepend the static origin
        if (fullUrl.origin === currentOrigin) {
          return targetOrigin + fullUrl.pathname + fullUrl.search + fullUrl.hash;
        } else {
          return url; // Leave it unchanged if not from current domain
        }
      } else {
        return url;
      }
    } catch (e) {
      return url;
    }

  }

  public static async LogDb(msg?: string, seq?: number, source?: string, loguser?: string) {
    try {
      const formData = new URLSearchParams();
      if (msg !== undefined) formData.append("msg", msg);
      if (seq !== undefined) formData.append("seq", seq.toString());
      if (source !== undefined) formData.append("source", source);
      if (loguser !== undefined) formData.append("loguser", loguser);
      // console.log('axios post ' + urls.WRITE_LOG, { msg, seq, source, loguser });
      const response = await axios.post(urls.WRITE_LOG, formData, {
        headers: {
          // 'Content-Type': 'multipart/form-data',
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Api-Key': 'Yj082LzvIOmEcgP9DL+6bw==',
        },
      });
      return response;
    } catch (error) {
      console.error(error);
    }
    // const api = new APIClient();
    // await api.fnPostForm(urls.WRITE_LOG, {
    //   source: source,
    //   msg: msg,
    //   loguser: user,
    //   seq: seq
    // });
  }

  public static async GetExternalUrl(callFrom: string, url: string, extUserId: any, customerIsCdSys: any): Promise<string> {
    const url2 = Utils.ConvertUrlIfItIsInternalChat(url);
    if (url2 !== url) { // it is inside chat link
      return url2;
    }
    const needExt = Utils.IsUrlNeedExternalParsing(callFrom, url, extUserId, customerIsCdSys);
    if (!needExt) return url;
    // call api to get new URL
    const api = new APIClient
    const parm = {
      customerIsCdSys: customerIsCdSys,
      extUserId: extUserId,
      link: url
    };
    // console.log('getExternalLink:', parm);
    const apiRs = await api.fnPostForm(urls.GET_EXTERNAL_LINK, parm);
    // console.log('get rs:', apiRs);

    if (apiRs.success) {
      return apiRs.data;
    } else {
      throw (new Error(apiRs.message));
    }
  }

  public static GetBaseUrl(): string {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    return baseUrl;
  }



  // public static async GetDbData(id: number): Promise<any> {
  //   const db = await this.OpenDb();
  //   return new Promise((resolve, reject) => {
  //     const transaction = db.transaction(STORE_NAME, "readonly");
  //     const store = transaction.objectStore(STORE_NAME);
  //     const request = store.get(id);

  //     request.onsuccess = () => resolve(request.result);
  //     request.onerror = () => reject(request.error);
  //   });
  // }



  static GetAllLocalStorageKey = (): string => {
    let keys: string[] = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        keys.push(key);
      }
      if (i >= 10) break;
    }
    return keys.join(",");
  }

  static ParseAlertMessage = (message: string) => {
    return message.replaceAll("Request failed with status code 401", "ยืนยันตัวตนไม่ผ่าน กรุณาล๊อกอินใหม่ (Err:401)");
  }

  static SweetAlert = (/*title: string,*/ message: string, customWidth: string = '600px') => {
    return Swal.fire({
      // title: message,
      html: Utils.ParseAlertMessage(message),
      icon: 'info',
      showCancelButton: false,
      confirmButtonText: 'ตกลง',
      width: customWidth,
    });
  }

  static GoToAppStore = (): void => {
    const storeUrl = Utils.GetAppStoreUrl();
    if (storeUrl) window.open(storeUrl, "_blank");
  };

  // guards against the cached-state resume gate (routes/index.tsx) and a fresh network check
  // both trying to show the blocking force-update dialog at (nearly) the same time
  private static isForceUpdateDialogOpen = false;

  // Force-update is a hard gate, not a one-time nag: routes/index.tsx re-shows this on every
  // resume (using the last cached result, before the network round-trip even completes) for as
  // long as forceupdate stays true, so dismissing it by tapping "update now" without actually
  // installing doesn't grant lasting access - it just reopens next time the app is foregrounded.
  static ShowAppUpdateResult = (result: AppUpdateCheckResult) => {
    if (result.forceupdate) {
      if (Utils.isForceUpdateDialogOpen) return;
      Utils.isForceUpdateDialogOpen = true;
      Swal.fire({
        title: "จำเป็นต้องอัปเดต",
        html: result.shortinfo || "กรุณาอัปเดตแอปเป็นเวอร์ชันใหม่เพื่อใช้งานต่อ",
        icon: "warning",
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: "อัปเดตตอนนี้",
      }).then(Utils.GoToAppStore).finally(() => { Utils.isForceUpdateDialogOpen = false; });
    } else if (result.isuptodate === false) {
      Swal.fire({
        title: "มีอัปเดตใหม่",
        html: result.shortinfo || "มีเวอร์ชันใหม่ให้อัปเดต",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "อัปเดต",
        cancelButtonText: "ไว้ทีหลัง",
      }).then((r) => { if (r.isConfirmed) Utils.GoToAppStore(); });
    } else {
      Swal.fire({
        title: "คุณใช้เวอร์ชันล่าสุดแล้ว",
        icon: "success",
        confirmButtonText: "ตกลง",
      });
    }
  }

  static SweetConfirm = (confirmMessage: string) => {
    return Swal.fire({
      title: 'ยืนยัน',
      html: confirmMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
    });
  }

  static SweetTextArea = (prompt: string, defValue: string, placeHolder?: string | null): Promise<string | null> => {
    return Swal.fire({
      title: prompt,
      input: 'textarea',
      inputLabel: '',
      inputPlaceholder: placeHolder ?? "",
      inputValue: defValue,
      showCancelButton: true
    }).then((result) => {
      if (result.isConfirmed) {
        return result.value;
      } else {
        return null;
      }
    });
  }

  static IsValidMobileNo = (value: string): boolean => {
    return /^[0-9]{10}$/.test(value ?? "");
  }

  // validate: return an error message string to keep the dialog open and show it in red under the input,
  // or null/undefined to accept the value and close the dialog.
  static SweetPromptText = (
    prompt: string,
    defValue: string,
    placeHolder?: string | null,
    validate?: (value: string) => Promise<string | null | undefined> | string | null | undefined
  ): Promise<string | null> => {
    return Swal.fire({
      title: prompt,
      input: 'text',
      inputLabel: '',
      inputPlaceholder: placeHolder ?? "",
      inputValue: defValue,
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
      showLoaderOnConfirm: !!validate,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: validate ? async (value: string) => {
        const err = await validate(value);
        if (err) {
          Swal.showValidationMessage(err);
          return false;
        }
        return value;
      } : undefined,
    }).then((result) => {
      if (result.isConfirmed) {
        return result.value;
      } else {
        return null;
      }
    });
  }

  static GetUniqueId(): string {
    return uuidv4();
  }

  static GetDeviceId(): string {
    return Utils.GenerateDeviceId();
  }

  static GenerateDeviceId(): string {
    let id = localStorage.getItem("did4");
    if (!id) {
      id = uuidv4();
      localStorage.setItem("did4", id);
    }
    return id;
  }

  static GetWpStatus(status: WpStatus): string {
    switch (status) {
      case WpStatus.Open: return "เปิด";
      case WpStatus.Cancel: return "ยกเลิก";
      case WpStatus.Close: return "ปิด";
      case WpStatus.Postpone: return "เลื่อน";
    }
    return "เปิด";
  }

  static GetDSignActionIconClass(action: string): string {
    switch (action) {
      case "Approved": return "fas fa-check-circle text-success";
      case "Rejected": return "fas fa-times-circle text-danger";
      case "Cancel": return "fas fa-ban text-muted";
      case "Pending": return "fas fa-clock text-warning";
      default: return "far fa-circle text-secondary"; // None
    }
  }

  static GetDSignApproveStatusIconClass(status?: string | null): string {
    switch (status) {
      case "Open": return "fas fa-hourglass-half text-warning";
      case "Cancel": return "fas fa-ban text-muted";
      case "Rejected": return "fas fa-times-circle text-danger";
      case "Finished": return "fas fa-check-double text-success";
      default: return "far fa-circle text-secondary";
    }
  }

  static GetDSignApproveStatusText(status?: string | null): string {
    switch (status) {
      case "Open": return "รออนุมัติทำ";
      case "Cancel": return "ยกเลิก";
      case "Rejected": return "ไม่อนุมัติให้ทำ";
      case "Finished": return "อนุมัติให้ทำ";
      default: return "-";
    }
  }

  static GetDSignApproveStatusColor(status?: string | null): string {
    switch (status) {
      case "Open": return "var(--bs-warning)";
      case "Cancel": return "var(--bs-secondary)";
      case "Rejected": return "var(--bs-danger)";
      case "Finished": return "var(--bs-success)";
      default: return "var(--bs-secondary)";
    }
  }

  static GetDSignActionText(action?: string | null): string {
    switch (action) {
      case "Approved": return "อนุมัติแล้ว";
      case "Rejected": return "ปฏิเสธแล้ว";
      case "Cancel": return "ยกเลิกแล้ว";
      case "Pending": return "รอดำเนินการ";
      default: return "รอถึงคิว"; // None
    }
  }

  static isAndriod = this.GetDeviceOS() == "Android";
  static isApple = this.GetDeviceOS() == "MacOS" || this.GetDeviceOS() == "iOS";

  static ChangePdfLinkHref(htmlContent: string): string {
    if (!htmlContent) return htmlContent;
    const convertAllPdfToGoogleView = false;//true;
    if (convertAllPdfToGoogleView || this.isAndriod) {
      // Create a temporary div to parse HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;

      // Find all <a> tags inside the content
      const links = tempDiv.querySelectorAll("a");

      links.forEach((link) => {
        const href = link.getAttribute("href") ?? "";
        const hrefLower = href?.toLowerCase();
        if (hrefLower && (
          hrefLower.includes(".pdf")
          || hrefLower.includes("/service/printsr2/ref=")
          || hrefLower.includes("/warehouse/reports/issueorderreportuser/viewpdffile?code=")
          || hrefLower.includes("/warehouse/reports/aivoucherreport?code=")
          || hrefLower.includes("/warehouse/reports/sellinvoicereport?code=")
        )) {
          let url2 = href;
          if (hrefLower.startsWith("/")) { // 20250708 Give absolute URL (no domain) then input full domain 
            url2 = process.env.REACT_APP_URL_FOR_STATIC + href;
          }
          // Modify the href to use Google Drive Viewer
          // if (href.includes("202503190901054")){
          // console.log('from:' + href);
          link.href = `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(url2/*href*/)}`;
          //link.href = `https://docs.google.com/gview?embedded=true&url=${href}`;
          // console.log('to:' + encodeURIComponent(href));
          // }
        }
      });

      // Update the htmlContent with modified links
      return tempDiv.innerHTML;
    } else {
      return htmlContent;
    }
  }

  // Native (Capacitor) loads the app from https://localhost (Android) / capacitor://localhost
  // (iOS), not the real domain — so root-relative resource paths coming from the DB (e.g.
  // "/test/test.jpg") resolve against that fake origin and 404. On web/PWA the app IS served
  // from the real domain, so this is a no-op there.
  static FixResourceUrlForNative(url: string): string {
    if (!url) return url;
    if (!Capacitor.isNativePlatform()) return url;
    if (!url.startsWith("/") || url.startsWith("//")) return url;
    // CRA's own bundle output (JS/CSS/media, e.g. a locally-imported placeholder image) always
    // lives under /static/ and is served same-origin - it's never backend-hosted content, so
    // rewriting it to REACT_APP_APIURL would point at a path the backend doesn't serve at all.
    if (url.startsWith("/static/")) return url;
    const baseUrl = process.env.REACT_APP_APIURL || "";
    return baseUrl + url;
  }

  // Same fix as FixResourceUrlForNative, applied to every img/video/audio/source[src] found
  // inside an HTML blob (e.g. DB-authored bodyHtml/htmlContent rendered via dangerouslySetInnerHTML).
  static FixRelativeResourceUrlsForNative(htmlContent: string): string {
    if (!htmlContent) return htmlContent;
    if (!Capacitor.isNativePlatform()) return htmlContent;
    // Cheap bail-out: most messages are plain text with no media tag at all, so skip the
    // DOM parse below for them — matters when loading a batch (e.g. ~100 conversations at once).
    if (!/\ssrc=["']\//.test(htmlContent)) return htmlContent;

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    tempDiv.querySelectorAll("img[src], video[src], audio[src], source[src]")
      .forEach((el) => {
        const value = el.getAttribute("src");
        if (value) el.setAttribute("src", Utils.FixResourceUrlForNative(value));
      });

    return tempDiv.innerHTML;
  }

  static GetMessageFromExecption = (err: any): string => {
    let msg = err?.message ?? String(err ?? "Unknown error");
    if (err?.response?.data) {
      if (err.response?.data?.message) {
        msg += ":" + err.response?.data?.message;
      } else {
        msg += ":" + err.response?.data;
      }
    }
    return msg;
  }

  static HandleException(err: any, showAlert: boolean | null = true) {
    let msg = Utils.GetMessageFromExecption(err);
    console.error(err);
    console.error(msg);
    if (showAlert) {
      let goLogin = false;
      if (msg == "Network Error") {
        //msg = "Network Error\nอย่าเพิ่งปิด กรุณาติดต่อเจ้าหน้าที่ IT เพื่อดู log ประกอบ สำหรับการหาสาเหตุ และแนวทางแก้ไขต่อไป";
      } else if (msg == "Request failed with status code 401") {
        msg = "การยืนยันตัวตนไม่สำเร็จ กรุณาล๊อกอินใหม่ (error 401)";
        goLogin = true;
      }
      alert(msg.replaceAll("Request failed with status code 500:", ""));
      // Utils.SweetAlert(msg).then(rs => {
      //   if (goLogin) {
      //     window.location.href = "/auth-register-phone?login=1";
      //   }
      // });

    }
  }

  static GetMemberRoleText = (wpMode: WpModes, memberRole: MemberRole): string => {
    switch (memberRole) {
      case MemberRole.Owner: return "หัวข้อหลัก";
      case MemberRole.Follower: return "เกี่ยวข้อง";
      case MemberRole.Observer: return "ไม่ติดตาม";
      case MemberRole.TagMe: return "กล่าวถึงฉัน";
      case MemberRole.MyPost: return "โพสของฉัน";
      case MemberRole.Flag: return "ติดธง";
      case MemberRole.Organize: return "ตามสายงาน";
      case MemberRole.PersonFollow: return "ติดตาม";
      case MemberRole.Subscribe: return "Subscribe";
      case MemberRole.All: return wpMode == WpModes.Workplace ? "โพสทั้งหมด" : "งานทั้งหมด";

      case MemberRole.TaskMine: return "งานของฉัน";
      case MemberRole.TaskAssigner: return "งานที่มอบหมาย";
      case MemberRole.TaskReqBy: return "ผู้ของาน";
      case MemberRole.TaskCreator: return "ผู้สร้างงาน";
      case MemberRole.TaskRelated: return "เกี่ยวข้อง";
    }
    return "หัวข้อหลัก";
  }

  static GetMemberRoleIcon = (wpMode: WpModes, memberRole: MemberRole): string => {
    switch (memberRole) {
      case MemberRole.Owner: return "🔴";
      case MemberRole.Follower: return "🧲";
      case MemberRole.Observer: return "📖";
      case MemberRole.TagMe: return "🌀";
      case MemberRole.MyPost: return "Ⓜ️";
      case MemberRole.Flag: return "🚩";
      case MemberRole.Organize: return "🧩";
      case MemberRole.PersonFollow: return "🧩";
      case MemberRole.Subscribe: return "🥏";
      case MemberRole.All: return wpMode == WpModes.Workplace ? "🌐" : "☑️";

      case MemberRole.TaskMine: return "🎯";
      case MemberRole.TaskAssigner: return "👉";
      case MemberRole.TaskReqBy: return "✒️";
      case MemberRole.TaskCreator: return "✒️";
      case MemberRole.TaskRelated: return "ℹ️";
    }
    return "หัวข้อหลัก";
  }

  static GetMemberRoleFromStorage = (wpMode: WpModes): MemberRole => {
    const suffix = wpMode == WpModes.Workplace ? "" : "tk";
    //const val = localStorage.getItem("memberRole");
    const val = localStorage.getItem(`memberRole${suffix}`);
    // if (!val) return MemberRole.Owner;
    if (!val) return MemberRole.All;
    if (val == String(MemberRole.Owner)) return MemberRole.Owner;
    if (val == String(MemberRole.Follower)) return MemberRole.Follower;
    if (val == String(MemberRole.Observer)) return MemberRole.Observer;
    if (val == String(MemberRole.TagMe)) return MemberRole.TagMe;
    if (val == String(MemberRole.MyPost)) return MemberRole.MyPost;
    if (val == String(MemberRole.Flag)) return MemberRole.Flag;
    if (val == String(MemberRole.Organize)) return MemberRole.Organize;
    if (val == String(MemberRole.PersonFollow)) return MemberRole.PersonFollow;
    if (val == String(MemberRole.Subscribe)) return MemberRole.Subscribe;
    if (val == String(MemberRole.All)) return MemberRole.All;

    if (val == String(MemberRole.TaskMine)) return MemberRole.TaskMine;
    if (val == String(MemberRole.TaskAssigner)) return MemberRole.TaskAssigner;
    if (val == String(MemberRole.TaskReqBy)) return MemberRole.TaskReqBy;
    if (val == String(MemberRole.TaskCreator)) return MemberRole.TaskCreator;
    if (val == String(MemberRole.TaskRelated)) return MemberRole.TaskRelated;

    // return MemberRole.Owner;
    return MemberRole.All;
  }

  static SetMemberRoleToStorage = (wpMode: WpModes, memberRole: MemberRole) => {
    const suffix = wpMode == WpModes.Workplace ? "" : "tk";
    // localStorage.setItem("memberRole", memberRole.toString());
    localStorage.setItem(`memberRole${suffix}`, memberRole.toString());
  }

  // Scoped by wpMode so a Workplace redirect and a Task redirect can't steal/clear each
  // other's guard flag - Workplace's and Task's title-list loads run concurrently on mount,
  // and both used to read/clear the same unscoped key regardless of which one it was meant for.
  //
  // Time-windowed rather than single-use-then-cleared: this flag has two independent readers -
  // wpSaga.ts force-includes the postId in the next title fetch, while WorkplaceTitle.tsx and
  // Chats/index.tsx use it purely as "don't clobber the just-redirected post" guard against their
  // own unrelated mount-time bootstrap effects (title list refresh, auto-select default chat
  // company) that unconditionally clear the active post. Clearing it as soon as the *first*
  // reader consumed it left the other readers unprotected whenever they happened to run after -
  // an ordering that flips unpredictably with real network latency. A fixed guard window lets
  // every reader see the same answer regardless of which one happens to run first.
  static REDIRECT_POST_GUARD_MS = 5000;

  static SetRedirectPostId = (wpMode: WpModes, postId: string) => {
    const suffix = wpMode == WpModes.Workplace ? "" : "Tk";
    localStorage.setItem(`${SKeys.RedirectWpId}${suffix}`, `${postId}|${Date.now() + Utils.REDIRECT_POST_GUARD_MS}`);
  }

  static GetRedirectPostId = (wpMode: WpModes): string | null => {
    const suffix = wpMode == WpModes.Workplace ? "" : "Tk";
    const key = `${SKeys.RedirectWpId}${suffix}`;
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const sepIndex = raw.lastIndexOf("|");
    const postId = sepIndex >= 0 ? raw.slice(0, sepIndex) : raw;
    const expiry = sepIndex >= 0 ? (Utils.ToNumber(raw.slice(sepIndex + 1), 0) ?? 0) : 0;
    if (Date.now() > expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return postId;
  }

  static ClearRedirectPostId = (wpMode: WpModes) => {
    const suffix = wpMode == WpModes.Workplace ? "" : "Tk";
    localStorage.removeItem(`${SKeys.RedirectWpId}${suffix}`);
  }

  static GetMemberRoleIconText = (wpMode: WpModes, memberRole: MemberRole): string => {
    return Utils.GetMemberRoleIcon(wpMode, memberRole) + " " + Utils.GetMemberRoleText(wpMode, memberRole);
  }

  static ConvertHtmlToText = (html: string): string => {
    if (!html) return "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || "";
  };

  static GetMessageDividerElement = (time: any): any => {
    return {
      type: "date-divider",
      //date: currentDate, // Include the date in the divider
      text: Utils.IsToday(time) ? "วันนี้" : Utils.GetShortDateTimeToShowInChat(time, true),
      isRead: true,
      mId: 'date-divider',
      time: time

      // mId: 'MSG0008xxx',
      // text:  Utils.IsToday(time) ? "วันนี้" :  Utils.GetShortDateTimeToShowInChat(time, true),
      // time: '2024-12-06T04:50:15.07Z',
      // senderId: 37441,
      // senderImg: '',
      // isFromMe: false,
      // readerPcnt: 0,
      // readerCount: 0,
      // readerRead: 0,
      // isRead: false,
      // senderName: 'ปูทดสอบ คนเดียว',
      // image: null,
      // attachments: null            
    };
  }

  static GetTaskStatusForShowInSelect = (): { value: string; label: string }[] => {
    return Utils.GetTaskStatusForShow().map(x => ({
      value: x.toString(),
      label: Utils.GetTaskStatusText(x)
    }));
  }

  static GetTaskStatusFromVal = (val: number | null): TaskStatus | null => {
    if (val == null) return null;

    return TaskStatus[val] !== undefined
      ? (val as TaskStatus)
      : null;
  }

  static GetTaskStatusForShow = (): TaskStatus[] => {
    return [
      TaskStatus.ToDo,
      TaskStatus.OnGoing,
      TaskStatus.Finished,
      TaskStatus.Hold,
      TaskStatus.Cancel,
    ];
  }

  static GetTaskStatusText = (taskStatus: TaskStatus | null): string => {
    switch (taskStatus) {
      case null: return 'Not Start';
      case TaskStatus.ToDo: return "To-Do";
      case TaskStatus.OnGoing: return "On Going";
      case TaskStatus.Finished: return "Finished";
      case TaskStatus.Hold: return "Hold";
      case TaskStatus.Cancel: return "Cancel";
    }
  }

  static GetTaskStatusIcon = (taskStatus: TaskStatus | null): string => {
    switch (taskStatus) {
      case null: return '⏳';
      case TaskStatus.ToDo: return "🔜";
      case TaskStatus.OnGoing: return "💪";
      case TaskStatus.Finished: return "✅";
      case TaskStatus.Hold: return "⏸️";
      case TaskStatus.Cancel: return "❌";
    }
  }

  static GetTaskStatusFromOverdueDateText = (status: TaskStatus | null, overdue: number | null, upcomingDay: number | null): string => {
    let startText = "เริ่มใน";
    if (status === TaskStatus.Finished || status === TaskStatus.Cancel) {
      overdue = null;
      startText = "เริ่มใน";//"รอบหน้าอีก";
    }

    if (overdue === null) {
      switch (upcomingDay) {
        case null: return "ยังไม่เริ่ม";
        case 0: return "เริ่มวันนี้";
        default:
          const dayText =
            upcomingDay > 360 ? (Utils.FormatNumber(upcomingDay / 360, 2) + " ปี")
              : upcomingDay > 45 ? (Utils.FormatNumber(upcomingDay / 30, 2) + " เดือน")
                : (Utils.FormatNumber(upcomingDay, 0)) + " วัน"
          return startText + " " + dayText;
      }
    }
    if (overdue === 0) return "ภายในวันนี้";
    if (overdue < 0) return "เสร็จใน " + (Utils.FormatNumber(-1 * overdue, 0)) + " วัน";
    if (overdue > 0) return "เลย " + (Utils.FormatNumber(overdue, 0)) + " วัน";
    return "N/A";
  }

  static GetTaskStatusFromOverdueDateCss = (overdue: number | null): string => {
    if (overdue === null) return "none";
    if (overdue === 0) return "today";
    if (overdue < -7) return "far";
    if (overdue < 0) return "near";
    if (overdue > 7) return "over2";
    if (overdue > 0) return "over1";
    return "none";
  }


  static IsImageFile = (fileName: any, fileType: any): boolean => {
    const fileNameLower = fileName.toLowerCase();
    const isImage =
      fileType.startsWith("image/") ||
      fileNameLower.endsWith(".heic") ||
      fileNameLower.endsWith(".heif") ||
      fileNameLower.endsWith(".avif") ||
      fileNameLower.endsWith(".webp");
    return isImage;
  }

  static getDateRangeText = (date1: Date, date2: Date): String => {
    const pad = (n: number) => n.toString().padStart(2, "0");

    const d1 = pad(date1.getDate());
    const m1 = pad(date1.getMonth() + 1);
    const y1 = date1.getFullYear();

    const d2 = pad(date2.getDate());
    const m2 = pad(date2.getMonth() + 1);
    const y2 = date2.getFullYear();

    return `${d1}/${m1}/${y1} - ${d2}/${m2}/${y2}`;
    // // Same year & same month
    // if (y1 === y2 && m1 === m2) {
    //   return `${d1} to ${d2} ${m1} ${y1}`;
    // }

    // // Same year, different month
    // if (y1 === y2) {
    //   return `${d1}/${m1} to ${d2}/${m2} ${y1}`;
    // }

    // // Different year
    // return `${d1}/${m1}/${y1} to ${d2}/${m2}/${y2}`;
  }

  static InsertDividerDateInChatMessage = (messages: any[]): any[] => {
    if (!Array.isArray(messages) || messages.length === 0) return messages;

    const processedMessages: any[] = [];
    let lastDate: string | null = null;

    // Helper function to format date
    const formatDate = (time: string | number | Date) =>
      new Date(time).toLocaleDateString(); // Format to 'MM/DD/YYYY'

    for (const message of messages) {
      if (message.type == "date-divider") continue;

      const currentDate = formatDate(message.time);

      // Insert a divider if the date changes
      if (currentDate !== lastDate) {
        processedMessages.push(Utils.GetMessageDividerElement(message.time));
        lastDate = currentDate;
      }

      // Add the original message to the processed list
      processedMessages.push(message);
    }

    return processedMessages;
  }

  static IsMatchAnyInArray(value: string[], keyword: string): boolean {
    if (!value || !keyword) return false;

    const keywords = keyword.toLowerCase().split(/\s+/).filter(k => k !== "");

    return value.some(val => {
      const valLower = val.toLowerCase();
      return keywords.some(k => valLower.includes(k));
    });
  }

  static IsMatchAny(value: string, keyword: string): boolean {
    if (!value || !keyword) return false;

    const valueLower = value.toLowerCase();
    const keywords = keyword.toLowerCase().split(/\s+/);
    // console.log('keywords:', keywords);

    return keywords.some(k => k !== "" && valueLower.includes(k));
  }

  static IsMatchAll(value: string, keyword: string): boolean {
    if (keyword === "") return true;

    if (!value || !keyword) return false;

    const valueLower = value.toLowerCase();
    const keywords = keyword.toLowerCase().split(/\s+/);

    return keywords.every(k => k !== "" && valueLower.includes(k));
  }


  static IsViewAs(): boolean {
    const val = localStorage.getItem("isViewAs");
    if (!val) return false;
    return Boolean(val);
  }

  static IsViewAsAlert(): boolean {
    const isViewAs = this.IsViewAs();
    if (isViewAs) {
      alert('ไม่อนุญาติ ในมุมมองคนอื่น');
    }
    return isViewAs;
  }

  static IsLocalHost(): boolean {
    return window.location.port === "3000";
  }

  static GetShortNameIcon(firstName: string, lastName: string): string {
    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`;
    } else if (firstName) {
      return `${firstName.charAt(0)}`;
    } else if (lastName) {
      return `${lastName.charAt(0)}`;
    }
    return firstName + ' ' + lastName;
  }

  static GetDeviceOS(): DeviceOS {
    const userAgent: string = navigator.userAgent || navigator.vendor || (window as any).opera;
    //console.log('userAgent: ', userAgent);
    let deviceOS: DeviceOS;
    if (/android/i.test(userAgent)) {
      deviceOS = "Android";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      deviceOS = "iOS";
    } else if (/Macintosh/.test(userAgent)) {
      deviceOS = "MacOS";
    } else if (/Win/.test(userAgent)) {
      deviceOS = "Windows";
    } else {
      deviceOS = "Unknown OS";
    }
    return deviceOS;
  }

  static APP_UPDATE_INFO_KEY = "appUpdateInfo";

  // platform buckets the raw os down to exactly "android"/"ios" for backend comparison logic;
  // anything that isn't clearly one of those (Windows, Unknown OS, ...) passes through unchanged
  // so the backend can still see it rather than have it silently coerced.
  static GetAppUpdatePlatform(os: string): string {
    if (os === "Android") return "android";
    if (os === "iOS" || os === "MacOS") return "ios";
    return os;
  }

  // native only (per check-app-update-chatnative contract) - PWA/web updates itself via the service worker.
  // os stays the broad GetDeviceOS() value (Android/iOS/MacOS/Windows/Unknown OS) so the backend can
  // still see exactly what it was, e.g. MacOS - platform is the normalized ios/android bucket.
  static GetAppUpdateCheckDeviceInfo(): { browser: string; device: string; os: string; platform: string } {
    const parser = new UA();
    const os = Utils.GetDeviceOS();
    return {
      browser: parser.getBrowser().name ?? "Unknown",
      device: parser.getDevice().type ?? "desktop",
      os,
      platform: Utils.GetAppUpdatePlatform(os),
    };
  }

  static GetUserTypeCodeForUpdateCheck(userType?: number | null): string | null {
    switch (userType) {
      case UserTypes.Employee: return "emp";
      case UserTypes.Customer: return "cus";
      case UserTypes.Supplier: return "sup";
      default: return null; // not authenticated, or a user type this check doesn't distinguish
    }
  }

  static SetAppUpdateInfo(info: AppUpdateCheckResult): void {
    localStorage.setItem(Utils.APP_UPDATE_INFO_KEY, JSON.stringify({ ...info, checkedAt: new Date().toISOString() }));
  }

  // debug/testing only - drops the cached result (and its checkedAt throttle timestamp) so the
  // next check runs unthrottled, as if this device had never checked before.
  static ClearAppUpdateInfo(): void {
    localStorage.removeItem(Utils.APP_UPDATE_INFO_KEY);
  }

  static GetAppUpdateInfo(): (AppUpdateCheckResult & { checkedAt?: string }) | null {
    try {
      const raw = localStorage.getItem(Utils.APP_UPDATE_INFO_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  // elapsed-time based (not calendar-day based) so "resume after being away" only re-checks
  // once at least 24h have actually passed since the last check, regardless of wall-clock date.
  static ShouldCheckAppUpdateNow(): boolean {
    const info = Utils.GetAppUpdateInfo();
    if (!info?.checkedAt) return true;
    const elapsedMs = Date.now() - new Date(info.checkedAt).getTime();
    return elapsedMs >= 24 * 60 * 60 * 1000;
  }

  static GetAppStoreUrl(): string | null {
    const platform = Capacitor.getPlatform();
    if (platform === "android") return process.env.REACT_APP_ANDROID_STORE_URL || null;
    if (platform === "ios") return process.env.REACT_APP_IOS_STORE_URL || null;
    return null;
  }

  static GetBrowser(): string {
    const userAgent: string = navigator.userAgent;

    if (/chrome|crios/i.test(userAgent) && !/edg|opr|brave/i.test(userAgent)) {
      return "Chrome";
    } else if (/firefox|fxios/i.test(userAgent)) {
      return "Firefox";
    } else if (/safari/i.test(userAgent) && !/chrome|crios|brave/i.test(userAgent)) {
      return "Safari";
    } else if (/opr|opera/i.test(userAgent)) {
      return "Opera";
    } else if (/edg/i.test(userAgent)) {
      return "Edge";
    } else if (/msie|trident/i.test(userAgent)) {
      return "Internet Explorer";
    } else {
      return "Unknown Browser";
    }
  }

  static GenerateDeviceIdOld(): string {
    // 1. Home URL of the PWA app
    // const homeUrl: string = "https://chat02.com";
    const homeUrl: string = window.location.origin; // This retrieves the base URL (e.g., https://chat02.com)

    // 2. Detect the Operating System
    const userAgent: string = navigator.userAgent || navigator.vendor || (window as any).opera;
    //console.log('userAgent: ', userAgent);
    let deviceOS: DeviceOS;
    if (/android/i.test(userAgent)) {
      deviceOS = "Android";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      deviceOS = "iOS";
    } else if (/Macintosh/.test(userAgent)) {
      deviceOS = "MacOS";
    } else if (/Win/.test(userAgent)) {
      deviceOS = "Windows";
    } else {
      deviceOS = "Unknown OS";
    }

    // 3. Detect the Browser
    let deviceBrowser: DeviceBrowser;
    if ((userAgent.indexOf("Opera") || userAgent.indexOf('OPR')) != -1) {
      deviceBrowser = 'Opera';
    } else if (userAgent.indexOf("Edg") != -1) {
      deviceBrowser = 'Edge';
    } else if (userAgent.indexOf("Chrome") != -1) {
      deviceBrowser = 'Chrome';
    } else if (userAgent.indexOf("Safari") != -1) {
      deviceBrowser = 'Safari';
    } else if (userAgent.indexOf("Firefox") != -1) {
      deviceBrowser = 'Firefox';
    } else {
      deviceBrowser = 'Unknown';
    }



    // 4. Determine the Device Type
    const deviceType: DeviceType = /Mobile|Android|iPhone|iPad/i.test(userAgent) ? "Mobile" : "PC";

    // Combine all attributes into a single string
    const deviceInfoString: string = `${homeUrl}|${deviceOS}|${deviceBrowser}|${deviceType}`;
    return deviceInfoString;
    // Create a simple hash of the device info string
    // const deviceId: string = hashString(deviceInfoString);
    // return deviceId;
  }

  static IsDesktop() {
    // const isDesktop = !/Mobi|Android|iPhone|iPad|Windows Phone/i.test(navigator.userAgent);
    // return isDesktop;

    const ua = navigator.userAgent || navigator.vendor;

    const isMobile = /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(ua);
    const isTablet = /Tablet|iPad/i.test(ua);
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 1;

    return !isMobile && !isTablet && !isTouch;
  }

  static IsRunningInPWA(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true;
  }

  static IsRunningInPWAMobile(): boolean {
    return !Utils.IsDesktop() && Utils.IsRunningInPWA();
  }

  static IsIOS(): boolean {
    const ua = navigator.userAgent || navigator.vendor;
    return /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  static sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private static LogFCM = (line: number, message: string | undefined): string => {
    const key = `logfcm_${line}`;
    if (message !== undefined) {
      // console.log(key + ' = ' + message);
      localStorage.setItem(key, message);
    }
    return localStorage.getItem(key) ?? "";
  }
  static LogFCM0 = (message: string | undefined): string => { return this.LogFCM(0, message); }
  static LogFCM1 = (message: string | undefined): string => { return this.LogFCM(1, message); }
  static LogFCM2 = (message: string | undefined): string => { return this.LogFCM(2, message); }
  static LogFCM3 = (message: string | undefined): string => { return this.LogFCM(3, message); }
  static LogFCM4 = (message: string | undefined): string => { return this.LogFCM(4, message); }
  static LogFCM5 = (message: string | undefined): string => { return this.LogFCM(5, message); }
  static LogFCM6 = (message: string | undefined): string => { return this.LogFCM(6, message); }
  static LogFCM7 = (message: string | undefined): string => { return this.LogFCM(7, message); }
  static LogFCM8 = (message: string | undefined): string => { return this.LogFCM(8, message); }
  static LogFCM9 = (message: string | undefined): string => { return this.LogFCM(9, message); }
  static GetLogFcm = () => {
    let logs = new Array();
    logs.push(this.LogFCM0(undefined));
    logs.push(this.LogFCM1(undefined));
    logs.push(this.LogFCM2(undefined));
    logs.push(this.LogFCM3(undefined));
    logs.push(this.LogFCM4(undefined));
    logs.push(this.LogFCM5(undefined));
    logs.push(this.LogFCM6(undefined));
    logs.push(this.LogFCM7(undefined));
    logs.push(this.LogFCM8(undefined));
    logs.push(this.LogFCM9(undefined));
    // console.log(logs);
    const log2 = logs.filter((msg) => msg !== undefined && msg !== "");
    // console.log(log2);
    return log2 ?? [];
  }

  static ClearLogFcm = () => {
    for (let i = 0; i < 10; ++i) {
      localStorage.removeItem(`logfcm_${i}`);
    }
  }

  static JwtTokenSet = (token?: string | null) => {
    if (token) {
      localStorage.setItem("jtk", token);
    } else {
      localStorage.removeItem("jtk");
    }
  }

  static JwtTokenGet = (): string => {
    const token = localStorage.getItem("jtk") ?? "";
    if (token) {
      // Utils.LogDb(`Read token = ${token} from device ${Utils.GetDeviceId()}`);
      const payload = JSON.parse(atob(token.split('.')[1]));
      const now = Math.floor(Date.now() / 1000);
      const expired = payload.exp < now;
      if (expired) {
        try { // 20250826 for #debug
          Utils.LogDb(`JWT token ${token} is expired`, 0, "Utils.JwtTokenGet", Utils.GetDeviceId());
        } catch { }
        localStorage.removeItem("jtk");
        return "";
      }
    }
    return token;
  }

  // Native (Capacitor) view-as token, sent as X-Vas-Token header on every API call
  // and on the SignalR hub handshake, since native has no cookie to carry it.
  static VasTokenSet = (token?: string | null) => {
    if (token) {
      localStorage.setItem("vtk", token);
    } else {
      localStorage.removeItem("vtk");
    }
  }

  static VasTokenGet = (): string => {
    return localStorage.getItem("vtk") ?? "";
  }

  // Native (Capacitor Android/iOS) token flow. Uses @capacitor-firebase/messaging,
  // which returns a real FCM token on both platforms (unlike @capacitor/push-notifications,
  // whose iOS token is a raw APNs token) so the backend keeps accepting FCM tokens unchanged.
  static GetFCMTokenNative = async (loadFromStorage: boolean, bForceRefreshToken?: boolean | null) => {
    let currentToken = loadFromStorage ? localStorage.getItem('ftk') : null;
    if (bForceRefreshToken) {
      try {
        await FirebaseMessaging.deleteToken();
      } catch (e2) {
        console.error(e2);
      }
      // deleteToken() invalidates whatever was cached in storage - without clearing
      // currentToken here, the `if (!currentToken)` below would skip fetching a new one
      // and this function would just hand back the now-dead token as if refresh succeeded.
      currentToken = null;
    }
    if (!currentToken) {
      let permStatus = await FirebaseMessaging.checkPermissions();
      if (permStatus.receive !== 'granted') {
        permStatus = await FirebaseMessaging.requestPermissions();
      }
      if (permStatus.receive === 'granted') {
        Utils.LogFCM0('Notification granted, get FCM token (native)');
        if (Capacitor.getPlatform() === 'ios') {
          // iOS FCM tokens must be bound to a real APNs device token (delivered async to
          // AppDelegate.didRegisterForRemoteNotificationsWithDeviceToken) before they're
          // usable for sending. Calling getToken() immediately after permission is granted
          // races that native round-trip: Firebase can hand back a token that's never bound
          // to APNs, and the backend then sees FCM 404 UNREGISTERED when it tries to push to
          // it. The working sup_connect Flutter app works around the same iOS SDK behavior
          // by checking getAPNSToken() and waiting before calling getToken() - mirrored here.
          Utils.LogFCM0('iOS: waiting for APNs token registration before requesting FCM token');
          await new Promise((resolve) => setTimeout(resolve, 2000));
        }
        const result = await FirebaseMessaging.getToken();
        currentToken = result.token;
        if (currentToken) {
          Utils.LogFCM1("Done subscribe get token " + currentToken);
          localStorage.setItem('ftk', currentToken);
        } else {
          Utils.LogFCM1("Faild to subscribe token");
        }
      } else {
        Utils.LogFCM0('Notification not granted');
      }
    }
    return currentToken;
  };

  static GetFCMToken = async (loadFromStorage: boolean, bForceRefreshToken?: boolean | null) => {
    try {
      this.ClearLogFcm();

      if (Capacitor.isNativePlatform()) {
        return await Utils.GetFCMTokenNative(loadFromStorage, bForceRefreshToken);
      }

      // Check if token is already stored in local storage
      let currentToken = loadFromStorage ? localStorage.getItem('ftk') : null;
      if (bForceRefreshToken) {
        try {
          await deleteToken(messaging);
        } catch (e2) {
          console.error(e2);
        }
        // deleteToken() invalidates whatever was cached - without this, `if (!currentToken)`
        // below would skip fetching a new one and hand back the now-dead token as "refreshed".
        currentToken = null;
      }
      if (!currentToken) {
        // console.log('get token');
        // Token not found, so request a new one
        if (isNotificationPermissionGranted()) {
          Utils.LogFCM0('Notification granted, get FCM token');
          currentToken = await getToken(messaging, { vapidKey: process.env.REACT_APP_VAPID_KEY, });
          // if (1 == 1) throw new Error("Registration failed - push service error");
          if (currentToken) {
            Utils.LogFCM1("Done subscribe get token " + currentToken);
            //console.log('New FCM Token:', currentToken);
            // Store the token locally
            localStorage.setItem('ftk', currentToken);
            // Send the token to the backend if needed
          } else {
            Utils.LogFCM1("Faild to subscribe token");
            //console.log('No registration token available. Request permission to generate one.');
          }
        } else {
          Utils.LogFCM0('Notification not granted');
          //console.log('Not get token because notification is not granted');
        }
      } else {
        // console.log('Using existing FCM Token:', currentToken);
      }
      return currentToken;
    } catch (error) {
      Utils.LogFCM9((error as any).message);
      throw (error);
    }
  };

  // Single entry point for the "please enable notifications" prompt used by
  // Login.tsx / SystemSetting.tsx. Native uses the OS permission dialog via
  // the plugin; web keeps using the existing browser Notification API flow
  // (askForPushNotification, defined in public/js/pwa-install.js) unchanged.
  // Single entry point for setting the app icon badge count. Android has no OS-level
  // badge API, so native uses @capawesome/capacitor-badge (wraps ShortcutBadger); web
  // keeps using the Badging API (navigator.setAppBadge) exactly as before.
  static SetAppBadge = async (count: number): Promise<void> => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Badge.set({ count });
      } catch (error) {
        console.error('Error setting badge:', error);
      }
      return;
    }
    if ('setAppBadge' in navigator) {
      try {
        await navigator.setAppBadge(count);
      } catch (error) {
        console.error('Error setting badge:', error);
      }
    }
  };

  static AskForPushNotification = async (bSilent: boolean): Promise<string> => {
    if (Capacitor.isNativePlatform()) {
      const status = await FirebaseMessaging.requestPermissions();
      return status.receive; // 'granted' | 'denied' | 'prompt' | 'prompt-with-rationale'
    }
    return askForPushNotification(bSilent);
  };

  // Current push permission state, for driving UI (e.g. the "enable notifications" button
  // in Login.tsx). Native push doesn't depend on the WebView's Notification API at all, so
  // it's checked separately here rather than reusing the web-only global function directly.
  static IsPushNotificationGrantedAsync = async (): Promise<boolean | undefined> => {
    if (Capacitor.isNativePlatform()) {
      try {
        const status = await FirebaseMessaging.checkPermissions();
        return status.receive === 'granted';
      } catch (error) {
        console.error('Error checking push permission:', error);
        return false;
      }
    }
    return isNotificationPermissionGranted();
  };

  // Whether push notifications are supported at all (distinct from granted/denied).
  // Native is always supported via the Capacitor plugin; web mirrors the existing
  // "does the browser have the Notification API" check (undefined = unsupported).
  static IsPushNotificationSupported = (): boolean => {
    if (Capacitor.isNativePlatform()) return true;
    return isNotificationPermissionGranted() !== undefined;
  };

  // Whether the app is "installed" — always true natively (it's already running as an
  // installed native app), otherwise mirrors the existing PWA install-prompt check.
  static IsAppInstalled = (): boolean => {
    if (Capacitor.isNativePlatform()) return true;
    return isPWAInstalled();
  };

  // Setting: whether to always show a push notification, even while the app is in the
  // foreground (default off — only show when the app is inactive/backgrounded, since the
  // in-app real-time message already covers the foreground case). Stored in localStorage
  // as the source of truth for the UI toggle, and mirrored to whichever store the
  // background handler that actually decides whether to show it can reach:
  // - Web: the service worker (public/firebase-messaging-sw.js) can't access localStorage
  //   at all, so the value is mirrored into IndexedDB (readable from a SW).
  // - Native: ChatMessagingService.java can't reach the WebView's localStorage either, so
  //   the value is mirrored into @capacitor/preferences (native SharedPreferences), read
  //   directly there via the same "CapacitorStorage" file/key the plugin uses.
  private static PUSH_ALWAYS_SHOW_KEY = 'pushAlwaysShow';
  private static PUSH_SETTINGS_IDB_NAME = 'chat2s-settings';
  private static PUSH_SETTINGS_IDB_STORE = 'kv';

  static GetPushAlwaysShowForeground = (): boolean => {
    return localStorage.getItem(Utils.PUSH_ALWAYS_SHOW_KEY) === '1';
  };

  static SetPushAlwaysShowForeground = async (value: boolean): Promise<void> => {
    localStorage.setItem(Utils.PUSH_ALWAYS_SHOW_KEY, value ? '1' : '0');
    try {
      if (Capacitor.isNativePlatform()) {
        await Preferences.set({ key: Utils.PUSH_ALWAYS_SHOW_KEY, value: value ? '1' : '0' });
      } else {
        await Utils.MirrorPushAlwaysShowToIndexedDb(value);
      }
    } catch (error) {
      console.error('Error saving push-always-show setting:', error);
    }
  };

  private static MirrorPushAlwaysShowToIndexedDb = (value: boolean): Promise<void> => {
    return new Promise((resolve, reject) => {
      const req = indexedDB.open(Utils.PUSH_SETTINGS_IDB_NAME, 1);
      req.onupgradeneeded = () => {
        req.result.createObjectStore(Utils.PUSH_SETTINGS_IDB_STORE);
      };
      req.onsuccess = () => {
        const db = req.result;
        try {
          const tx = db.transaction(Utils.PUSH_SETTINGS_IDB_STORE, 'readwrite');
          tx.objectStore(Utils.PUSH_SETTINGS_IDB_STORE).put(value, Utils.PUSH_ALWAYS_SHOW_KEY);
          tx.oncomplete = () => { db.close(); resolve(); };
          tx.onerror = () => { db.close(); reject(tx.error); };
        } catch (e) {
          db.close();
          reject(e);
        }
      };
      req.onerror = () => reject(req.error);
    });
  };

  static GetFCMTokenForApiParm = async (): Promise<any> => {
    const token = await this.GetFCMToken(false);
    if (!token) return null;
    return {
      endpoint: token,
      p256dh: '',
      auth: '',
      deviceid: localStorage.getItem("did4") ?? "",
      // Must match updateFcmTokenAsync's platform check (src/api/profile.ts) - this same
      // token/device also gets upserted via /me and /logout, and hardcoding AppChat2S here
      // was overwriting the AppChat2SNative tag set by the push/subscribe call, causing
      // the backend to send native FCM tokens under the wrong app identity ("invalid
      // registration token" even though the token itself was correct).
      frontEndApp: Capacitor.isNativePlatform() ? FrontEndApp.AppChat2SNative : FrontEndApp.AppChat2S
    };
  }

  static ArrayBufferToBase64 = (buffer: ArrayBuffer): string => {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    bytes.forEach((byte) => (binary += String.fromCharCode(byte)));
    return window.btoa(binary);
  };

  static Test = (value: any): boolean => {
    return true;
  }

  static IsDarkTheme = (): boolean => {
    return localStorage.getItem("lm") == "dark";
  }

  static GetCssSuffixTheme = (prefix: string | null): string => {
    const dash = prefix ? "-" : "";
    return (prefix ?? "") + dash + ((Utils.IsDarkTheme() ? "dark" : "light"));
  }

  static IsNumeric = (value: any) => {
    if (value == null || value === undefined)
      return false;

    if (typeof value === 'number') return true;

    if (value == "")
      return false;

    value = value.replace(',', '');
    value = value.replace(/,/g, '');

    if (isNaN(value)) {
      return false;
    }

    return true;
  }

  static FormatNumber = (number: any, digit: number): string => {
    if (!number) number = 0;
    const formatted = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: digit,
      maximumFractionDigits: digit,
    }).format(number);
    return formatted;
  }

  static FormatPhoneNo10 = (phoneNumber: string): string => {
    // Remove any non-digit characters
    const cleaned = phoneNumber.replace(/\D/g, '');

    // Check if the cleaned number is exactly 10 digits
    if (cleaned.length !== 10) {
      return cleaned;
    }

    // Format the number as xxx-xxx-xxxx
    const formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;

    return formatted;
  }

  static Is2S = (profile2: UserStruct): boolean => {
    if (!profile2) return false;
    return profile2.userType == UserTypes.Employee;
  }

  static GetUserTypeAttr = (userType: UserTypes, attr: "TEXT" | "BADGE" | "BG") => {
    if (!userType) return "";
    const name = UserTypes[userType]; // Get the string name of the UserType
    return UserTypeInfo[attr][name as keyof typeof UserTypeInfo[typeof attr]]; // Type assertion
  }

  static GetUserRoleAttr = (userRole: UserRoles, attr: "TEXT" | "BADGE" | "BG") => {
    if (!userRole) return "";
    const name = UserRoles[userRole]; // Get the string name of the UserRole
    return UserRoleInfo[attr][name as keyof typeof UserRoleInfo[typeof attr]]; // Type assertion
  }

  static GetUserTypeText = (userType: UserTypes) => { return this.GetUserTypeAttr(userType, 'TEXT'); }
  static GetUserTypeBadge = (userType: UserTypes) => { return this.GetUserTypeAttr(userType, 'BADGE'); }
  static GetUserTypeBg = (userType: UserTypes) => { return this.GetUserTypeAttr(userType, 'BG'); }

  static GetUserRoleText = (userRole: UserRoles) => { return this.GetUserRoleAttr(userRole, 'TEXT'); }
  static GetUserRoleBadge = (userRole: UserRoles) => { return this.GetUserRoleAttr(userRole, 'BADGE'); }
  static GetUserRoleBg = (userRole: UserRoles) => { return this.GetUserRoleAttr(userRole, 'BG'); }

  static ToBool(value: any, def: boolean): boolean {
    if (value === null || value === undefined || value === '') {
      return def;
    }

    const normalized = String(value).toLowerCase().trim();

    return ['1', 'true', 'yes', 'ok'].includes(normalized);
  }

  static ToNumber(value: any, def: number | null): number | null {
    if (value == null) return def;
    if (value === undefined) return def;
    value = value.toString().replace('%', ''); // remove % symbol
    value = value.toString().replace(/,/g, ''); // regular expression to replace all , to ''. Above replace function just replace one occurance.
    var v = Number(value);
    if (isNaN(v)) {
      if (def != null && def !== undefined) {
        v = def;
      }
    }
    return v;
  }

  static GetFirstNotNull(...values: (string | null | undefined)[]): string | undefined | null {
    return values.find(value => value !== null && value !== undefined && value.trim() !== "");
  }


  static Profile2ToProfileBasicDetail = (profile2: any): any => {
    const fullName = (profile2.firstName || profile2.lastName) ? ([profile2.firstName, profile2.lastName].join(" ").trim()) : profile2.nickName;
    const firstName = profile2.firstName ? profile2.firstName : profile2.nickName;
    //console.log('Profile2ToProfileBasicDetail:', profile2);

    const basicDetails = {
      firstName: firstName,
      lastName: profile2.lastName,
      title: profile2.authMobileNo,
      description: '-',
      fullName: fullName,
      email: profile2.email ?? '-',
      location: profile2.location ?? '-',
      avatar: profile2.pictureUrl,
      coverImage: defaultCoverImage,
      userType: profile2.userType,
      userRole: profile2.userRole,
      positionName: profile2.positionName,
      companyName: profile2.companyName,
      groupInviteCode: profile2.GroupInviteCode,
      userId: profile2.userId,
      abbrName: profile2.abbrName,
      foreColor: profile2.foreColor,
      bgColor: profile2.bgColor,
      displayName2: profile2.displayName2,
      isAdmin: profile2.isAdmin,
      isItSupport: profile2.isItSupport,
    }
    return basicDetails;
  }

  static ToggleClass = (element: any, className: any) => {
    if (element.classList.contains(className)) {
      element.classList.remove(className);
    } else {
      element.classList.add(className);
    }
  }

  static GetCurrentDateTime = () => new Date();

  static GetCurrentDateTimeLongFormat = () => {
    const now = Utils.GetCurrentDateTime();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so we add 1
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
  }

  static IsToday = (givenDate: any): boolean => {
    const today = new Date();
    const givenDate2 = new Date(givenDate);

    return (
      today.getFullYear() === givenDate2.getFullYear() &&
      today.getMonth() === givenDate2.getMonth() &&
      today.getDate() === givenDate2.getDate()
    );
  }


  static ConvertApiDate = (apiDate: any): Date | null => {
    if (!apiDate) return null;

    // Already Date
    if (apiDate instanceof Date) {
      return isNaN(apiDate.getTime()) ? null : apiDate;
    }

    if (typeof apiDate !== "string") return null;

    const value = apiDate.trim();
    if (!value) return null;

    let date = apiDate;
    let time = '';
    if (apiDate.includes('T')) {
      const ar = apiDate.split('T');
      date = ar[0];
      time = ar[1];
    } else if (apiDate.includes(' ')) {
      const ar = apiDate.split(' ');
      date = ar[0];
      time = ar[1];
    }
    const arDate = date.split('-');
    const arTime = time.split(':');
    const year = Number(arDate.length == 3 ? arDate[0] : 0);
    const month = Number(arDate.length == 3 ? arDate[1] : 0);
    const day = Number(arDate.length == 3 ? arDate[2] : 0);
    const hour = Number(arTime.length > 0 ? arTime[0] : 0);
    const minute = Number(arTime.length > 1 ? arTime[1] : 0);
    const second = Number(arTime.length > 2 ? arTime[2] : 0);
    const dateValue = new Date(year, month - 1, day, hour, minute, second);
    // if (apiDate == "2026-02-20T00:00:00") {
    //   console.log({ apiDate, year, month, day, hour, minute, second, dateValue });
    //   console.log(new Date(2026,2,20,0,0,0));
    // }
    return dateValue;
  };



  static GetDMY = (apiDate: any, includeWeekDay: boolean = false): string => {
    const date = Utils.ConvertApiDate(apiDate);
    if (!date) return "";
    //const date = new Date(apiDate);
    //return date.toLocaleDateString('th-TH', { day: '2-digit', month: '2-digit', year: 'numeric' });
    // const dmy = date.toLocaleDateString(culture, { day: '2-digit', month: '2-digit', year: 'numeric' });
    const weekdayTH = includeWeekDay ? new Intl.DateTimeFormat("th-TH", {
      weekday: "short"
    }).format(date) : "";

    const dmy =
      (includeWeekDay ? (weekdayTH + " ") : "") +
      String(date.getDate()).padStart(2, '0') + '/' +
      String(date.getMonth() + 1).padStart(2, '0') + '/' +
      date.getFullYear();


    return dmy;
  }

  static GetDMYHHMM = (apiDate: any): string => {

    // if (!apiDate) return "";
    // const date = new Date(apiDate);
    // return date.toLocaleDateString('th-TH', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    const date = Utils.ConvertApiDate(apiDate);

    if (!date) return "";
    const dmy =
      String(date.getDate()).padStart(2, '0') + '/' +
      String(date.getMonth() + 1).padStart(2, '0') + '/' +
      date.getFullYear() + ' ' +
      String(date.getHours()).padStart(2, '0') + ':' +
      String(date.getMinutes()).padStart(2, '0');
    return dmy;
  }

  static ToApiDateTimeString = (date: Date | null | undefined): string => {
    if (!date) return "";
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:00`;
  }

  static GetLastOnlineText = (onlineDate: any): string => {
    if (!onlineDate) return "never";

    const date = new Date(onlineDate);
    if (isNaN(date.getTime())) return "never";

    const now = new Date();
    const diffMs = now.getTime() - date.getTime();

    if (diffMs < 0) return "in the future";

    const sec = Math.floor(diffMs / 1000);
    const min = Math.floor(sec / 60);
    const hour = Math.floor(min / 60);
    const day = Math.floor(hour / 24);
    const week = Math.floor(day / 7);

    if (sec < 60) return "just now";
    if (min < 60) return `${min} minute${min > 1 ? "s" : ""} ago`;
    if (hour < 24) return `${hour} hour${hour > 1 ? "s" : ""} ago`;
    if (day < 7) return `${day} day${day > 1 ? "s" : ""} ago`;
    if (week < 5) return `${week} week${week > 1 ? "s" : ""} ago`;

    // fallback: show full date
    const dayS = String(date.getDate()).padStart(2, "0");
    const monthS = String(date.getMonth() + 1).padStart(2, "0");
    const yearS = date.getFullYear();
    return `${dayS}/${monthS}/${yearS}`;
    // return date.toLocaleDateString();
  };

  static GetShortDateTimeToShowInChat = (apiDate: any, forContactList: boolean): string => {
    if (!apiDate) return "";
    const date = new Date(apiDate);
    const today = new Date();

    // Helper functions
    const isSameDay = (d1: Date, d2: Date) =>
      d1.getDate() === d2.getDate() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getFullYear() === d2.getFullYear();

    const isYesterday = (d: Date) => {
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      return isSameDay(d, yesterday);
    };

    const isDayBeforeYesterday = (d: Date) => {
      const dayBeforeYesterday = new Date(today);
      dayBeforeYesterday.setDate(today.getDate() - 2);
      return isSameDay(d, dayBeforeYesterday);
    };

    const isInLast7Days = (d: Date) => {
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 7);
      return d > sevenDaysAgo;
    };

    const isInCurrentMonth = (d: Date) =>
      d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear();

    const isInCurrentYear = (d: Date) => d.getFullYear() === today.getFullYear();

    // Check conditions and return appropriate format
    const timeHHMM = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    const dMMMM = date.toLocaleDateString('th-TH', { day: 'numeric', month: 'short' });
    if (isSameDay(date, today)) {
      return timeHHMM;
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    } else if (isYesterday(date)) {
      return "เมื่อวาน" + (forContactList ? "" : (" " + timeHHMM));
    } else if (isDayBeforeYesterday(date)) {
      return dMMMM + (forContactList ? "" : (" " + timeHHMM));
      //return "วานซืน";
    } else if (isInLast7Days(date)) {
      return dMMMM + (forContactList ? "" : (" " + timeHHMM));
      // return date.toLocaleDateString('th-TH', { weekday: 'long' }).replace("วัน", ""); // Thai short weekday
    } else if (isInCurrentMonth(date)) {
      return dMMMM + (forContactList ? "" : (" " + timeHHMM));
      // return date.toLocaleDateString('th-TH', { day: 'numeric', month: 'short' }); // "d MMM"
    } else if (isInCurrentYear(date)) {
      return dMMMM + (forContactList ? "" : (" " + timeHHMM));
      // return date.toLocaleDateString('th-TH', { day: 'numeric', month: 'short' }); // "d MMM"
      // return date.toLocaleDateString('th-TH', { month: 'long' }); // "MMMM"
    } else {
      if (forContactList) {
        return date.toLocaleDateString('th-TH', { month: 'long', year: 'numeric' });
      } else {
        return date.toLocaleDateString('th-TH', { day: 'numeric', month: 'short', year: 'numeric' }) + " " + timeHHMM;
      }

      //return date.toLocaleDateString('th-TH', { month: 'long', year: 'numeric' }) + (forContactList ? "" : (" " + timeHHMM)); // "MMMM yyyy"
    }
  };

  static GetShortDateTimeToShowInChat_Old = (apiDate: any): string => {
    if (apiDate == "") return "";
    if (!apiDate) return "";
    const date = new Date(apiDate);
    const today = new Date();

    // Check if the date is today
    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();

    if (isToday) {
      // Format as HH:mm (24-hour) for today's date
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    } else {
      // Format as dd/MM/yy for other dates
      return date.toLocaleDateString('en-GB'); // en-GB gives dd/MM/yyyy format
    }
  }

  static ToLocalDateString = (date: Date): string => {
    if (!date) return "";//20260117
    if (!(date instanceof Date)) date = new Date(date);
    if (isNaN(date.getTime())) return "";
    // const date = new Date();
    // Convert to a local ISO string manually (preserving local time)
    const pad = (n: number) => n.toString().padStart(2, '0');

    const localDateString = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

    // console.log(localDateString); // e.g. "2025-06-25T10:24:49"
    return localDateString;

  }

  static DateAdd = (apiDate: any, increase: number, unit: "second" | "minute" | "hour" | "day"): Date => {
    const date = new Date(apiDate);

    if (isNaN(date.getTime())) {
      throw new Error("Invalid date input");
    }

    switch (unit) {
      case "second":
        date.setSeconds(date.getSeconds() + increase);
        break;
      case "minute":
        date.setMinutes(date.getMinutes() + increase);
        break;
      case "hour":
        date.setHours(date.getHours() + increase);
        break;
      case "day":
        date.setDate(date.getDate() + increase);
        break;
    }

    return date;
  };

  static SetTime = (date: Date, hour: number, minute: number): Date => {
    const newDate = new Date(date);
    newDate.setHours(hour);
    newDate.setMinutes(minute);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);
    return newDate;
  }

  static GetApiInfo = (): any => {
    try {
      const apiInfo = localStorage.getItem("apiInfo");
      if (apiInfo) {
        return JSON.parse(apiInfo);
      } else {
        return {};
      }
    } catch (e) {
      return {};
    }
  }

  static CreateChatBotMessage(text: string) {
    return {
      mId: uuidv4(),
      text: text,
      senderId: -1,
      isFromMe: false,
      senderName: "BOT",
      senderPictureUrl: "/icons/chatbot.png",
      time: Utils.GetCurrentDateTimeLongFormat(),
      "meta": {
        "receiver": -1,
        "sender": -1,
        "senderName": "BOT",
        "sent": true,
        "received": true,
        "read": true,
        "isForwarded": false,
        "userData": {
          "userId": 0,
          "userType": 0,
          "isAdmin": false,
          "firstName": "hahahah",
          "lastName": "jigjig",
          "pictureUrl": "/icons/chatbot.png",
          "profileImage": "/icons/chatbot.png",
          "isActive": true,
          "chats": [],
        }
      }
    };
  }

  static GetThemeForReactSelect = () => {
    return Utils.IsDarkTheme() ? Utils.ReactSelectDarkThemeStyles : Utils.ReactSelectLightThemeStyles;

  }

  static readonly ReactSelectLightThemeStyles = {
    control: (base: any) => ({
      ...base,
      backgroundColor: '#fff',
      borderColor: '#ccc',
      color: '#000',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#999',
      },
      padding: '0em',

    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#f0f0f0' : '#fff',
      color: state.isSelected ? '#fff' : '#333',
      '&:active': {
        backgroundColor: '#007bff',
      },
      padding: '0em'
    }),
    singleValue: (base: any) => ({
      ...base,
      color: '#000',
      padding: '0em'
    }),
    menu: (base: any) => ({
      ...base,
      backgroundColor: '#fff',
      padding: '0em',
      zIndex: 9999   // ensures menu itself has high stacking
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 9999   // ensures portal menu is above all
    }),
    input: (base: any) => ({
      ...base,
      color: '#000', // Ensure the search text is visible in light theme
    }),
    multiValue: (base: any) => ({
      ...base,
      backgroundColor: '#e9ecef',
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      color: '#000',
    }),
    multiValueRemove: (base: any) => ({
      ...base,
      color: '#000',
      '&:hover': {
        backgroundColor: '#dc3545',
        color: '#fff',
      },
    }),
  };

  static readonly ReactSelectDarkThemeStyles = {
    control: (base: any) => ({
      ...base,
      backgroundColor: '#272626', //'#333',    
      borderColor: '#444',
      color: '#adb5bd',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#666',
      },
      padding: '0em'
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#555' : '#333',
      color: state.isSelected ? '#adb5bd' : '#ccc',
      '&:active': {
        backgroundColor: '#007bff',
      },
      padding: '0em'
    }),
    singleValue: (base: any) => ({
      ...base,
      color: '#adb5bd',
      padding: '0em'
    }),
    menu: (base: any) => ({
      ...base,
      backgroundColor: '#333',
      padding: '0em',
      zIndex: 9999   // ensures menu itself has high stacking
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 9999   // ensures portal menu is above all
    }),
    input: (base: any) => ({
      ...base,
      color: '#adb5bd', // Ensure the search text is visible in dark theme
    }),
    multiValue: (base: any) => ({
      ...base,
      backgroundColor: '#444',
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      color: '#adb5bd',
    }),
    multiValueRemove: (base: any) => ({
      ...base,
      color: '#adb5bd',
      '&:hover': {
        backgroundColor: '#666',
        color: '#fff',
      },
    }),
  };

  static Conf_Get = (key: string, def: string) => { return localStorage.getItem(key) ?? def; }
  static Conf_Set = (key: string, val: string) => { localStorage.setItem(key, val); return val; }


  static Conf_WorkPlaceTitle1Line = (value?: boolean) => {
    const def = false;
    return value ? Utils.Conf_Set(Conf_Keys.WorkPlaceTitle1Line, value.toString()) : (Utils.Conf_Get("cnf_wptl", def ? "1" : "0") == "1");
  }
  static Conf_WorkPlaceTitleShowLastChat = (value?: boolean): boolean => {
    const def = false;
    // return value ? Utils.Conf_Set("cnf_wptslc", value.toString()) : (Utils.Conf_Get("cnf_wptslc", def ? "1" : "0") == "1");
    if (value === null || value === undefined) {
      return (Utils.Conf_Get(Conf_Keys.WorkPlaceTitleShowLastChat, def ? "1" : "0") == "1");
    } else {
      // console.error("value:" + value);
      Utils.Conf_Set(Conf_Keys.WorkPlaceTitleShowLastChat, value ? "1" : "0");
      return value ? true : false;
    }
  }

  static Conf_WorkPlaceRememberFilter = (value?: boolean): boolean => {
    const key = Conf_Keys.WorkPlaceRememberFilter;
    const def = false;
    if (value === null || value === undefined) {
      return (Utils.Conf_Get(key, def ? "1" : "0") == "1");
    } else {
      Utils.Conf_Set(key, value ? "1" : "0");
      return value ? true : false;
    }
  }

  static Conf_ShareFilterWpTask = (value?: boolean): boolean => {
    const key = Conf_Keys.WorkPlaceShareFilterWpTask;
    const def = false;
    if (value === null || value === undefined) {
      return (Utils.Conf_Get(key, def ? "1" : "0") == "1");
    } else {
      Utils.Conf_Set(key, value ? "1" : "0");
      return value ? true : false;
    }
  }

  static Conf_WorkPlaceFilterUnread = (wpMode: WpModes, value?: boolean): boolean => {
    const key = wpMode == WpModes.Workplace ? Conf_Keys.WorkPlaceFilterUnread : Conf_Keys.WorkPlaceFilterUnreadTk;
    const def = false;
    if (value === null || value === undefined) {
      return (Utils.Conf_Get(key, def ? "1" : "0") == "1");
    } else {
      Utils.Conf_Set(key, value ? "1" : "0");
      return value ? true : false;
    }
  }

  static Conf_WorkPlaceFilterNotYetClose = (wpMode: WpModes, value?: boolean): boolean => {
    const key = wpMode == WpModes.Workplace ? Conf_Keys.WorkPlaceFilterNotYetClose : Conf_Keys.WorkPlaceFilterNotYetCloseTk;
    const def = true;
    if (value === null || value === undefined) {
      return (Utils.Conf_Get(key, def ? "1" : "0") == "1");
    } else {
      Utils.Conf_Set(key, value ? "1" : "0");
      return value ? true : false;
    }
  }

  static Conf_WorkPlaceSortMode = (wpMode: WpModes, value?: WpSortMode): WpSortMode => {
    const key = wpMode == WpModes.Workplace ? Conf_Keys.WorkPlaceSort : Conf_Keys.WorkPlaceSortTk;
    const def = WpSortMode.Latest;
    if (value === null || value === undefined) {
      const val = Number(Utils.Conf_Get(key, String(def)));
      if (val === WpSortMode.DueDate) return WpSortMode.DueDate;
      if (val === WpSortMode.ResponderName) return WpSortMode.ResponderName;
      return WpSortMode.Latest;
    } else {
      Utils.Conf_Set(key, String(value));
      return value;
    }
  }


  static IsValidLatLng = (lat: any, lng: any): boolean => {
    return (
      typeof lat === 'number' &&
      typeof lng === 'number' &&
      !isNaN(lat) &&
      !isNaN(lng) &&
      lat >= -90 &&
      lat <= 90 &&
      lng >= -180 &&
      lng <= 180
    );
  }

  static WpDraft_GetKey = (wpMode: WpModes, postId: string, returnPrefix?: boolean | null): string => {
    const newKey = wpMode == WpModes.Workplace ? "new" : "newtk";
    const dayOfMonth = new Date().getDate();
    const floor = Math.floor(dayOfMonth / 5);
    const id = (returnPrefix ? "" : (postId ? postId : newKey));
    const key = `wpdft_${floor.toString()}_${id}`;
    return key;
  }

  static WpDraft_Load = (wpMode: WpModes, postId: string): string => {
    const key = Utils.WpDraft_GetKey(wpMode, postId);
    // console.log('Load wp draft of ' + key);
    const val = localStorage.getItem(key) ?? "";
    return val;
  }

  static WpDraft_SaveTk = async (taskData: TaskFormFieldData | null) => {
    const key = Utils.WpDraft_GetKey(WpModes.Task, "newtask");
    const val = taskData == null ? "" : JSON.stringify(taskData);
    if (val == "") {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, val);
      // console.log('WpDraft_SaveTk:', { key, val });
    }
  }

  static WpDraft_LoadTk = async (): Promise<TaskFormFieldData | null> => {
    const key = Utils.WpDraft_GetKey(WpModes.Task, "newtask");
    const val = localStorage.getItem(key);

    if (!val) return null;

    try {
      return JSON.parse(val) as TaskFormFieldData;
    } catch {
      // optional: clean up bad data
      localStorage.removeItem(key);
      return null;
    }
  }

  static WpDraft_Save = async (wpMode: WpModes, postId: string, content: string, dispatch: AppDispatch) => {
    // console.log('WpDraft_Save:', {postId});
    const key = Utils.WpDraft_GetKey(wpMode, postId);
    if (content == "") {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, content);
    }
    if (postId != "") { // blank is new post, then no need to dispatch to prevent title change, don't remove this code its feecte to dispatch(setActivePostId2(null, null, null, null, null, "Title change and post not in title"));
      dispatch(setDraftPost(wpMode, postId, content !== ""));
    }
  }

  static WpDraft_Del = (wpMode: WpModes, postId: string, dispatch: AppDispatch) => {
    const key = Utils.WpDraft_GetKey(wpMode, postId);
    localStorage.removeItem(key);
    if (postId != "") { // blank is new post, then no need to dispatch to prevent title change, don't remove this code its feecte to dispatch(setActivePostId2(null, null, null, null, null, "Title change and post not in title"));
      dispatch(setDraftPost(wpMode, postId, false));
    }
  }

  static WpDraft_ClearOldKey = async () => {
    const keepKey1 = Utils.WpDraft_GetKey(WpModes.Workplace, "", true);
    const keepKey2 = Utils.WpDraft_GetKey(WpModes.Task, "", true);
    const keepKeys = [keepKey1, keepKey2];
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      //if (key?.startsWith("wpdft_") && !key.startsWith(keepKey)) {
      if (key?.startsWith("wpdft_") && !keepKeys.includes(key)) {
        keysToRemove.push(key);
      }
    }

    // Remove the matching keys
    if (keysToRemove.length > 0) {
      // console.log('remove key:', keysToRemove);
      keysToRemove.forEach(key => localStorage.removeItem(key));
    }
  }

  static WpDraft_GetAllPostId = () => {
    const postId = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith("wpdft_")) {
        const ee = key.split('_');
        if (ee.length == 3) {
          postId.push(ee[2]);
        }
      }
    }
    return postId;
  }

  static Tk_OpenTask = async (postId: string, openParentTask: boolean, dispatch: AppDispatch) => {
    if (postId == "") {
      alert('ยังไม่มีงาน');
      return;
    } else {
      try {
        const rs = await new APIClient().fnPostForm(urls.WP_TK_CAN_VIEW_TASK, { taskId: postId, checkForGoToParentTask: openParentTask });
        if (rs && rs.taskId) {
          dispatch(changeTab(TABS.TASK));
          dispatch(setActivePostId2(WpModes.Task, rs.taskId, null, null, null, null, "Tk_OpenTask"));
        } else {
          alert('ท่านไม่สามารถดูงานนี้ได้ อาจไม่ได้เป็นสมาชิกในงาน หรืออยู่นอกหน่วยงาน');
        }
      } catch (e) {
        Utils.HandleException(e, true);
      }
    }
  }

  static ToggleSubscribe = async (postIdTop: string, dispatch: AppDispatch, onLoading?: (loaidng: boolean) => void) => {
    try {
      onLoading?.(true);
      const api = new APIClient();
      const rs = await api.fnPostForm(urls.WP_TOGGLE_SUBSCRIBE_POST, { postIdTop });
      // console.log('ToggleSubscribe:', rs);
      dispatch(setActivePostId2(rs.postInfo.wpMode, rs.postInfo.postIdTop, rs.postInfo.title, rs.postInfo.abbrName, rs.postInfo.abbrFore, rs.postInfo.abbrBack, "Subscribe"));
      dispatch(apiOk(WpActionTypes.GET_ROLE_UNREAD_COUNT, rs.unreadByRole));
      onLoading?.(false);
    } catch (e) {
      Utils.HandleException(e, true);
      onLoading?.(false);
    }
  }

  static ShowWpTagInfo = (tagId: number) => {
    try {
      const api = new APIClient();
      if (tagId == -1) {
        alert('Invalid tag id');
      } else {
        api.fnPostForm(urls.WP_LOAD_TAG_INFO, { tagId: tagId })
          .then(rs => {
            // console.log('tag info:', rs);
            if (rs.length > 0) {
              let ar: string[] = [];
              let title = '';
              rs.forEach((el: any, index: number) => {
                if (index == 0) {
                  title = `Tag <span class="text-primary" tg="${tagId}">${el.catName} @${el.name}</span>`;
                  if (el.category == Const.WP_CAT_CUS) {
                    const erpUrl = Const.ERP_CUSTOMER_PAGE.replaceAll('[CustomerId]', el.tagKeyId);
                    title += `&nbsp;<a href="${erpUrl}" target="erp_cus_info_${el.tagKeyId}"><span class="badge badge-soft-primary rounded p-1 ml-1 bg-primary hand">ลูกค้ารายตัว</span></a>`;
                  }
                }
                if (el.memberCat) {
                  ar.push(`<tr><td>${el.memberCat}</td><td align="left"><i class="${el.memberIcon}"></i>&nbsp;${el.memberName}</td><td align="center">${el.memberRole}</td></tr>`);
                }
              });
              if (ar.length > 0) {
                alert(title + '<table width="100%">' + ar.join('') + '</table>');
              } else {
                alert(title + '<br/>ไม่มีสมาชิกใน tag');
              }

            } else {
              alert('Not found information of tag selected');
            }
          })
          .catch(e2 => Utils.HandleException(e2, true))
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  // 1. Get the first day of the week (usually Sunday)
  static GetFirstDateOfWeek = (date: Date | null): Date => {
    const d = date ? new Date(date) : new Date();
    const day = d.getDay();
    // If day is 0 (Sunday), we subtract 6 days. 
    // Otherwise, we subtract (day - 1) days.
    const diff = d.getDate() - (day === 0 ? 6 : day - 1);
    const firstDay = new Date(d.setDate(diff));

    firstDay.setHours(0, 0, 0, 0); // Optional: Reset time to start of day
    return firstDay;
  }

  // 2. Get the last day of the week (usually Saturday)
  static GetLastDateOfWeek = (date: Date | null): Date => {
    const d = date ? new Date(date) : new Date();
    const day = d.getDay();
    // If day is 0 (Sunday), it is already the last day.
    // Otherwise, we add (7 - day) days.
    const diff = day === 0 ? 0 : 7 - day;
    const lastDay = new Date(d.setDate(d.getDate() + diff));

    lastDay.setHours(23, 59, 59, 999); // Optional: Reset time to end of day
    return lastDay;
  }

  // 3. Get the first day of the month
  static GetFirstDateOfMonth = (date: Date | null): Date => {
    const d = date ? new Date(date) : new Date();
    return new Date(d.getFullYear(), d.getMonth(), 1);
  }

  // 4. Get the last day of the month
  static GetLastDateOfMonth = (date: Date | null): Date => {
    const d = date ? new Date(date) : new Date();
    return new Date(d.getFullYear(), d.getMonth() + 1, 0);
  }

  static Numbers2String = (nums: number[] | null): string => {
    return nums?.join(',') ?? "";
  }

  static String2Numbers = (str: string | null | undefined, sorted: boolean = false): number[] | undefined => {
    if (!str) return [];
    const xx = str.split(',').filter(x => Utils.IsNumeric(x)).map(x => Utils.ToNumber(x, -1) ?? -1);
    const x2 = sorted ? [...xx].sort((a, b) => a - b) : xx;
    return x2;
  }

  static GetTaskRecuranceFreqText = (data: TaskRecurance2Data | null): string => {
    switch (data!.recuranceMode) {
      case RecuranceModes.OneTime: return "ครั้งเดียว";
      case RecuranceModes.Daily: return `ทุก ${data!.freqDay} วัน`;
      case RecuranceModes.Weekly: return `ทุก ${data!.freqWeek} อาทิตย์`;
      case RecuranceModes.Monthly: return `ทุก ${data!.freqMonth} เดือน`;
      case RecuranceModes.Yearly: return `ทุก ${data!.freqYear} ปี`;
    }
    return "";
  }

  static ShowNextTaskRecuranceTable = async (data: TaskRecurance2Data) => {
    try {
      const api = new APIClient;
      const rs = await api.fnPostBody(urls.WP_GENERATE_TASK_RECURANCE_SCHEDULE, data);
      let table = ``;
      table += data.recuranceText ?? "";
      table += `<br/>เริ่ม: ${Utils.GetDMY(data.startDate, true)}, ล่าสุด ${Utils.GetDMY(data.lastTaskFinishedDate, true)}`;
      table += `<table width="100%" border="1">`;
      table += `  <tr><th>วันเริ่ม</th><th>กำหนดเสร็จ</th></tr>`;
      if (rs) {
        for (var i = 0; i < rs.length; ++i) {
          table += `  <tr><td align="right">${Utils.GetDMY(rs[i][0], true)}</td><td align="right">${Utils.GetDMY(rs[i][1], true)}</td></tr>`;
        }
      }
      table += `</table>`;
      alert(table);
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  static CheckTaskRecuranceData = (data: TaskRecurance2Data/*TaskRecuranceDtlData*/): string => {
    // console.log('CheckTaskRecuranceData:', data);
    const number = Utils.ToNumber(data.createTaskBefore, -1) ?? -1;
    let day = number;
    switch (data.createTaskBeforeUnit) {
      case "D": day = number; break;
      case "W": day = number * 7; break;
      case "M": day = number * 30; break;
      default: day = -1; break;
    }


    switch (data.recuranceMode) {
      case RecuranceModes.None:
        break;
      case RecuranceModes.OneTime:
        if (!data.specificDate) return "กรุณาระบุ วันที่ที่เสร็จ";
        if (day < 1) return "สร้างงานก่อนกำหนด ต้องมากกว่า 1 วัน";
        break;
      case RecuranceModes.Daily:
        // if (!data.dailyOnTime) return "กรุณาระบุเวลา ในงานประจำรายวัน";
        if (day > 1) return "สร้างงานก่อนกำหนด ต้องน้อยกว่า 2 วัน";
        break;
      case RecuranceModes.Weekly:
        if (!data.weeklyEveryWeekDay && !data.weeklyExceptDay) return "กรุณาระบุวัน ในงานประจำรายอาทิตย์";
        if (day > 7) return "สร้างงานก่อนกำหนด ต้องน้อยกว่า 8 วัน";
        break;
      case RecuranceModes.Monthly:
        if (!data.monthlyEveryDay) return "กรุณา ระบุวัน ในงานประจำรายเดือน";
        if (day > 30) return "สร้างงานก่อนกำหนด ต้องน้อยกว่า 31 วัน";
        break;
      case RecuranceModes.Yearly:
        if (!data.yearlyEveryDay) return "กรุณา ระบุวัน  ในงานประจำรายปี";
        if (!data.yearlyEveryMonth) return "กรุณา ระบุเดือน ในงานประจำรายปี"
        if (day > 360) return "สร้างงานก่อนกำหนด ต้องน้อยกว่า 1 ปี";
        break;
    }
    if (!data.createTaskBefore) return "กรุณาระบุ รายละเอียดของ 'สร้างงานก่อนครบกำหนด'";
    if (!data.createTaskBeforeUnit) return "กรุณาระบุ รายละเอียดของ 'สร้างงานก่อนครบกำหนด'";
    return "";
  }

  static GetTaskNumberName = (mode: "DAY" | "WDAY" | "MONTH", nums?: number[] | null | undefined): string => {
    if (!nums) return "";
    if (nums == null || nums.length <= 0) return "";

    if (mode == "DAY") {
      const ar = nums.map(x => x === Const.DAY_MONTH_END ? "สิ้นเดือน" : x === Const.DAY_MONTH_END_NEXT ? "เดือนถัดไป" : x.toString());
      const text = ar.join(",");
      return text;

    } else if (mode == "WDAY") {
      const ar = nums.map(x => {
        // console.log({x, No: Const.WEEK_DAY_NO, Name: Const.WEEK_DAY_NAME});
        const idx = Const.WEEK_DAY_NO.indexOf(x);
        const label = Const.WEEK_DAY_NAME[idx];
        return label;
      });
      const rs = ar.join(",");
      return rs;

    } else if (mode == "MONTH") {
      const ar = nums.map(x => x.toString());
      const text = ar.join(",");
      return text;
    }
    return "";
  }

  static GetTaskRecuranceExceptionText = (data: TaskRecurance2Data): string => {
    let excD, excW, excM;
    switch (data.recuranceMode) {
      case RecuranceModes.None: return "";
      case RecuranceModes.Daily:
        excD = Utils.GetTaskNumberName("DAY", Utils.String2Numbers(data.dailyExceptDay));
        excW = Utils.GetTaskNumberName("WDAY", Utils.String2Numbers(data.dailyExceptWeekDay));
        break;
      case RecuranceModes.Weekly:
        excD = Utils.GetTaskNumberName("DAY", Utils.String2Numbers(data.weeklyExceptDay));
        break;
      case RecuranceModes.Monthly:
        excW = Utils.GetTaskNumberName("WDAY", Utils.String2Numbers(data.monthlyExceptWeekDay));
        excM = Utils.GetTaskNumberName("MONTH", Utils.String2Numbers(data.monthlyExceptMonth));
        break;
      case RecuranceModes.Yearly:
        break;
    }
    let text = '';
    if (excD) text += " ยกเว้นวันที่ " + excD;
    if (excW) text += " ยกเว้นวัน " + excW;
    if (excM) text += " ยกเว้นเดือน " + excM;

    while (text.includes("  ")) {
      text = text.replaceAll("  ", " ");
    }
    return text.trim();
  }

  static GetTaskRecuranceText = (data: TaskRecurance2Data/*TaskRecuranceDtlData*/): string => {
    let incD, incW, excD, excW, excM, incM, text = "";
    switch (data.recuranceMode) {
      case RecuranceModes.None: return "";
      case RecuranceModes.OneTime: return `เสร็จภายใน ${Utils.GetDMYHHMM(data.specificDate)}`;
      case RecuranceModes.Daily:
        text = Utils.GetTaskRecuranceFreqText(data);
        excD = Utils.GetTaskNumberName("DAY", Utils.String2Numbers(data.dailyExceptDay));
        excW = Utils.GetTaskNumberName("WDAY", Utils.String2Numbers(data.dailyExceptWeekDay));
        break;
      case RecuranceModes.Weekly:
        text = Utils.GetTaskRecuranceFreqText(data);
        incW = Utils.GetTaskNumberName("WDAY", Utils.String2Numbers(data.weeklyEveryWeekDay));
        excD = Utils.GetTaskNumberName("DAY", Utils.String2Numbers(data.weeklyExceptDay));
        break;
      case RecuranceModes.Monthly:
        text = Utils.GetTaskRecuranceFreqText(data);
        incD = Utils.GetTaskNumberName("DAY", Utils.String2Numbers(data.monthlyEveryDay));
        excW = Utils.GetTaskNumberName("WDAY", Utils.String2Numbers(data.monthlyExceptWeekDay));
        excM = Utils.GetTaskNumberName("MONTH", Utils.String2Numbers(data.monthlyExceptMonth));
        break;
      case RecuranceModes.Yearly:
        text = Utils.GetTaskRecuranceFreqText(data);
        incD = Utils.GetTaskNumberName("DAY", Utils.String2Numbers(data.yearlyEveryDay));
        incM = Utils.GetTaskNumberName("MONTH", Utils.String2Numbers(data.yearlyEveryMonth));
        break;
    }
    if (incD) text += " ทุก ๆ วันที่ " + incD;
    if (incW) text += " ทุก ๆ วัน " + incW;
    if (excD) text += " ยกเว้นวันที่ " + excD;
    if (excW) text += " ยกเว้นวัน " + excW;
    if (excM) text += " ยกเว้นเดือน " + excM;
    if (incM) text += " ทุก ๆ เดือน " + incM;

    while (text.includes("  ")) {
      text = text.replaceAll("  ", " ");
    }
    return text.trim();
  }

  static SplitByCase = (str: string): string => {
    return str.replace(/([a-z])([A-Z])/g, "$1 $2");
  };

  /**
   * Every column of vw_hookdata_taskinfo, camelCased. The view is the single source of truth for the
   * task fields a hook can send, so keep this list in step with it whenever the view changes.
   * approveFlowJson and tagMemberJson are JSON array strings, not scalars.
   */
  static HookTaskViewFields: string[] = [
    "taskId", "taskName", "projectId", "assignerId", "respondId", "requesterId",
    "bodyHtml", "planFinishedDate", "actFinishedDate", "status", "statusDate",
    "parentTaskId", "isSubTask", "subTaskCount", "approveStatus", "approveRemark", "docType",
    "assignerExtId", "assignerName",
    "respondExtId", "respondName",
    "requesterExtId", "requesterName",
    "lastActionRole", "lastAction", "lastActionDate", "lastActionRemark", "lastActionUser",
    "lastUserId", "lastExtUserId",
    "approveFlowJson", "tagMemberJson",
  ];

  /**
   * Who triggered the event. Not part of vw_hookdata_taskinfo - the view describes the task, not the
   * actor - so it is added on top of the view fields.
   */
  static HookActorFields: string[] = ["userId", "extUserId", "userName"];

  /**
   * Thai meaning of every hook variable, shown from the ⓘ on the Body tab's Value column.
   * Keys must match the placeholder exactly - the camelCase ones for the four task events, and the
   * old PascalCase ones for ChangeTaskStatus / ChangeTaskStatusByHuman.
   */
  static HookFieldInfo: { [key: string]: { type: string; desc: string; sample: string; values?: string } } = {
    // ── ผู้ทำรายการ ──
    userId: { type: "number", desc: "รหัสผู้ใช้ที่ทำรายการ (0 หรือติดลบ = บอท, มากกว่า 0 = คน)", sample: "159" },
    extUserId: { type: "number", desc: "รหัสผู้ทำรายการในระบบภายนอก (ERP) ถ้าไม่มีจะส่ง 0", sample: "1968" },
    userName: { type: "string", desc: "ชื่อผู้ทำรายการ", sample: "Poo Smith bb" },

    // ── ข้อมูลงาน ──
    taskId: { type: "string (guid)", desc: "รหัสงาน (Task Id)", sample: "f883b711-3b84-4ddb-ae4c-4308428f568c" },
    taskName: { type: "string", desc: "ชื่องาน", sample: "ขอลาพักร้อน 3 วัน" },
    projectId: { type: "number", desc: "รหัสโครงการ", sample: "12  (ไม่มีโครงการ = ค่าว่าง)" },
    assignerId: { type: "number", desc: "รหัสผู้มอบหมายงาน", sample: "159" },
    respondId: { type: "number", desc: "รหัสเจ้าของงาน (ผู้รับผิดชอบ)", sample: "100" },
    requesterId: { type: "number", desc: "รหัสผู้ขอให้ทำงาน", sample: "87" },
    bodyHtml: { type: "string (html)", desc: "รายละเอียดงานแบบ HTML ⚠️ อาจยาวมาก ทำให้ payload ใหญ่", sample: "<p>รายละเอียดงาน <a class=\"a-tag\" atype=\"tag\" aval=\"79702\">@Chat.2S</a></p>" },
    planFinishedDate: { type: "date", desc: "วันกำหนดเสร็จตามแผน", sample: "2026-02-09" },
    actFinishedDate: { type: "date", desc: "วันที่เสร็จจริง", sample: "2026-02-04" },
    status: { type: "number", desc: "สถานะงาน ส่งเป็นตัวเลข ไม่ใช่ข้อความ", sample: "1", values: "1 = ToDo, 2 = Finished, 3 = Cancel, 4 = OnGoing, 5 = Hold" },
    statusDate: { type: "date", desc: "วันที่เปลี่ยนสถานะล่าสุด", sample: "2026-02-04" },
    parentTaskId: { type: "string (guid)", desc: "รหัสงานแม่ (ถ้างานนี้เป็นงานย่อย)", sample: "25a50827-225b-46dd-9803-0089d5ae76f2" },
    isSubTask: { type: "boolean", desc: "เป็นงานย่อยหรือไม่", sample: "false", values: "true, false" },
    subTaskCount: { type: "number", desc: "จำนวนงานย่อยของงานนี้", sample: "0" },
    approveStatus: { type: "string", desc: "สถานะการอนุมัติของทั้งงาน", sample: "Finished", values: "Open, Finished, Rejected, Cancel (ค่าว่าง = ยังไม่เคยส่งขออนุมัติ)" },
    approveRemark: { type: "string", desc: "เหตุผลล่าสุดของการปฏิเสธหรือยกเลิกการอนุมัติ", sample: "เอกสารแนบไม่ครบ" },
    docType: { type: "string", desc: "ประเภทเอกสาร (ใช้เป็นตัวกรอง DocType ได้)", sample: "leave" },

    // ── ชื่อและรหัสภายนอกของผู้เกี่ยวข้อง ──
    assignerExtId: { type: "number", desc: "รหัสผู้มอบหมายงานในระบบภายนอก (ERP)", sample: "1968" },
    assignerName: { type: "string", desc: "ชื่อผู้มอบหมายงาน", sample: "Poo Smith bb" },
    respondExtId: { type: "number", desc: "รหัสเจ้าของงานในระบบภายนอก (ERP)", sample: "822" },
    respondName: { type: "string", desc: "ชื่อเจ้าของงาน", sample: "อริศรา ถิ่นนุกูล (เรย์)" },
    requesterExtId: { type: "number", desc: "รหัสผู้ขอในระบบภายนอก (ERP)", sample: "6" },
    requesterName: { type: "string", desc: "ชื่อผู้ขอให้ทำงาน", sample: "ทรรศนีย์ ภูนุชอภัย" },

    // ── การอนุมัติล่าสุด ──
    lastActionRole: { type: "string", desc: "บทบาทของผู้ดำเนินการอนุมัติล่าสุด", sample: "ผู้อนุมัติของาน" },
    lastAction: { type: "string", desc: "การกระทำล่าสุดในสายอนุมัติ", sample: "Approved", values: "None = ยังไม่ถึงคิว, Pending = รอคนนี้พิจารณา, Approved = อนุมัติแล้ว, Rejected = ปฏิเสธแล้ว" },
    lastActionDate: { type: "datetime", desc: "วันเวลาที่ดำเนินการอนุมัติล่าสุด (ไม่มี timezone)", sample: "2026-08-13T13:23:30.547" },
    lastActionRemark: { type: "string", desc: "หมายเหตุที่ผู้ดำเนินการอนุมัติล่าสุดระบุไว้", sample: "อนุมัติตามที่ขอ" },
    lastActionUser: { type: "string", desc: "ชื่อผู้ดำเนินการอนุมัติล่าสุด", sample: "Aek Smith" },
    lastUserId: { type: "number", desc: "รหัสผู้ดำเนินการอนุมัติล่าสุด", sample: "111" },
    lastExtUserId: { type: "number", desc: "รหัสผู้ดำเนินการอนุมัติล่าสุดในระบบภายนอก (ERP)", sample: "737" },
    approveFlowJson: {
      type: "json array (string)",
      desc: "สายอนุมัติทั้งหมด เรียงตาม seq ส่งมาเป็น 'ข้อความ' ต้อง parse ก่อนใช้ " +
        "ถ้ายังไม่มีสายอนุมัติจะได้ [] — แต่ละ element มี key: seq, userId, extUserId, userName, " +
        "userFullName, roleName, roleDisplayName, action, requestDate, actionDate, remark, active, allFlowStatus",
      sample:
        "[\n" +
        "  {\"seq\":1,\"userId\":159,\"extUserId\":1968,\"userName\":\"Poo Smith bb\",\"userFullName\":\"กิติศักดิ์ แสงทอง\",\"roleName\":\"ผู้ยื่นขออนุมัติ\",\"roleDisplayName\":\"ผู้ยื่นขออนุมัติ\",\"action\":\"Approved\",\"requestDate\":\"2026-08-13T09:36:53.74\",\"actionDate\":\"2026-08-13T13:23:30.547\",\"remark\":null,\"active\":false,\"allFlowStatus\":\"Finished\"},\n" +
        "  {\"seq\":2,\"userId\":111,\"extUserId\":737,\"userName\":\"Aek Smith\",\"userFullName\":\"เอกศักดิ์ อมรมธุรพจน์\",\"roleName\":\"ผู้อนุมัติของาน\",\"roleDisplayName\":\"ผู้อนุมัติของาน\",\"action\":\"Pending\",\"requestDate\":\"2026-08-13T13:23:30.547\",\"actionDate\":null,\"remark\":null,\"active\":true,\"allFlowStatus\":\"Finished\"}\n" +
        "]",
      values: "action ในแต่ละ element: None, Pending, Approved, Rejected | allFlowStatus: Open, Finished, Rejected, Cancel",
    },
    tagMemberJson: {
      type: "json array (string)",
      desc: "สมาชิกที่ถูก tag ในงาน/โพสต์นี้ทั้งหมด (ไม่ซ้ำ) ส่งมาเป็น 'ข้อความ' ต้อง parse ก่อนใช้ " +
        "ถ้าไม่มีจะได้ [] — แต่ละ element มี key: chatUserId, extUserId, memberRole, memberRoleText, tagId, category, name " +
        "(extUserId มีค่าเฉพาะผู้ใช้จาก DConnect.Users, category/name เป็น null สำหรับ tag บทบาทของระบบ เช่น tagId -20/-21/-22)",
      sample:
        "[\n" +
        "  {\"chatUserId\":88,\"extUserId\":19,\"memberRole\":22,\"memberRoleText\":\"ผู้ของาน\",\"tagId\":-22,\"category\":null,\"name\":null},\n" +
        "  {\"chatUserId\":90,\"extUserId\":3,\"memberRole\":24,\"memberRoleText\":\"เกี่ยวข้อง\",\"tagId\":65423,\"category\":\"EMP\",\"name\":\"Keng Smith\"}\n" +
        "]",
      values: "memberRole: 1 = หัวข้อหลัก, 2 = เกี่ยวข้อง, 3 = กล่าวถึงฉัน, 4 = โพสของฉัน, 5 = ติดธง, 6 = ตามสายงาน, 7 = ติดตาม, " +
        "8 = ไม่ติดตาม, 9 = Subscribe, 20 = งานของฉัน, 21 = ผู้มอบหมายงาน, 22 = ผู้ของาน, 23 = ผู้สร้างงาน, 24 = เกี่ยวข้อง",
    },

    // ── เฉพาะบาง event ──
    statusOld: { type: "number", desc: "สถานะงานก่อนเปลี่ยน", sample: "1", values: "1 = ToDo, 2 = Finished, 3 = Cancel, 4 = OnGoing, 5 = Hold" },
    statusNew: { type: "number", desc: "สถานะงานหลังเปลี่ยน", sample: "2", values: "1 = ToDo, 2 = Finished, 3 = Cancel, 4 = OnGoing, 5 = Hold" },
    approveStatusOld: { type: "string", desc: "สถานะการอนุมัติก่อนเปลี่ยน", sample: "Open", values: "Open, Finished, Rejected, Cancel (ค่าว่าง = ยังไม่เคยส่งขออนุมัติ)" },
    approveStatusNew: { type: "string", desc: "สถานะการอนุมัติหลังเปลี่ยน", sample: "Finished", values: "Open, Finished, Rejected, Cancel" },
    stepSeq: { type: "number", desc: "ลำดับขั้นของผู้อนุมัติที่เพิ่งทำรายการ (ตรงกับ seq ใน approveFlowJson)", sample: "2" },
    stepAction: { type: "string", desc: "การกระทำของผู้อนุมัติคนที่เพิ่งทำรายการ", sample: "Approved", values: "Approved = อนุมัติ, Rejected = ปฏิเสธ, Recalled = เรียกคืนการอนุมัติ" },
    stepRemark: { type: "string", desc: "เหตุผลที่ผู้อนุมัติระบุ (กรณีปฏิเสธ)", sample: "เอกสารแนบไม่ครบ" },

    // ── ของ 2 event เดิม (ชื่อตัวแปรเป็น PascalCase คนละชุดกับด้านบน) ──
    UserId: { type: "number", desc: "รหัสผู้ใช้ที่ทำรายการ", sample: "159" },
    ExtUserId: { type: "number", desc: "รหัสผู้ทำรายการในระบบภายนอก (ERP)", sample: "1968" },
    UserName: { type: "string", desc: "ชื่อผู้ทำรายการ", sample: "Poo Smith bb" },
    TaskId: { type: "string (guid)", desc: "รหัสงาน (Task Id)", sample: "f883b711-3b84-4ddb-ae4c-4308428f568c" },
    TaskName: { type: "string", desc: "ชื่องาน", sample: "ขอลาพักร้อน 3 วัน" },
    StatusOld: { type: "number", desc: "สถานะงานก่อนเปลี่ยน", sample: "1", values: "1 = ToDo, 2 = Finished, 3 = Cancel, 4 = OnGoing, 5 = Hold" },
    StatusNew: { type: "number", desc: "สถานะงานหลังเปลี่ยน", sample: "2", values: "1 = ToDo, 2 = Finished, 3 = Cancel, 4 = OnGoing, 5 = Hold" },
    DocType: { type: "string", desc: "ประเภทเอกสาร", sample: "leave" },
    ApproveStatusOld: { type: "string", desc: "สถานะการอนุมัติก่อนเปลี่ยน", sample: "Open", values: "Open, Finished, Rejected, Cancel" },
    ApproveStatusNew: { type: "string", desc: "สถานะการอนุมัติหลังเปลี่ยน", sample: "Finished", values: "Open, Finished, Rejected, Cancel" },
  };

  static GetHookFieldInfo = (field: string): { type: string; desc: string; sample: string; values?: string } =>
    Utils.HookFieldInfo[field] ?? { type: "", desc: "", sample: "" };

  /**
   * When each event actually fires, written from the real backend call sites.
   *
   * ⚠️ MAINTENANCE: this text is a copy of backend behaviour, nothing enforces that it stays true.
   * If a call site moves or a condition changes, update the matching entry here as well.
   * Current sources (2026-09-02):
   *   ChangeTaskStatus / ChangeTaskStatusByHuman -> sp_hookqueue_tktaskstatus, called by sp_wpsavepostinfo
   *   TaskInfoChange / TaskStatusChanged         -> sp_hookqueue_task, called by sp_wpsavepostinfo
   *   TaskApprovalChanged                        -> WorkPlaceService.SendTaskApproval / DSignRecomputeActive /
   *                                                 CancelTaskApproval, WorkPlaceController.TkRejectStep
   *   TaskApproveStep                            -> WorkPlaceController.TkApproveStep / TkRejectStep / TkRecallStep
   */
  static HookEventInfo: { [key: string]: string } = {
    ChangeTaskStatus:
      "ยิงทุกครั้งที่สถานะงานเปลี่ยน (ค่าเก่า ≠ ค่าใหม่) ไม่ว่าคนหรือบอทเป็นผู้เปลี่ยน " +
      "⚠️ เป็น event รุ่นเดิม ไม่รองรับตัวกรอง DocType และ Include bot และชื่อตัวแปรเป็นแบบ PascalCase คนละชุดกับ event ใหม่",
    ChangeTaskStatusByHuman:
      "เหมือน Change Task Status แต่ยิงเฉพาะเมื่อผู้เปลี่ยนเป็นคน (userId > 0) เท่านั้น " +
      "⚠️ เป็น event รุ่นเดิม ไม่รองรับตัวกรอง DocType และ Include bot",
    TaskInfoChange:
      "ยิงเมื่อบันทึกข้อมูลงานแล้วมีการเปลี่ยนแปลงจริงอย่างน้อย 1 อย่าง ได้แก่ ชื่องาน ผู้มอบหมาย เจ้าของงาน ผู้ขอ " +
      "สถานะ วันกำหนดเสร็จ หรือมีการลบ tag รวมถึงตอนแปลง Post เป็น Task " +
      "(ถ้ากดบันทึกแต่ไม่มีอะไรเปลี่ยน จะไม่ยิง) " +
      "⚠️ การเพิ่ม tag อย่างเดียวจะไม่ยิง — รายชื่อใน {tagMemberJson} จะอัปเดตในครั้งถัดไปที่ event ยิง",
    TaskStatusChanged:
      "ยิงเมื่อสถานะงานเปลี่ยนจริงเท่านั้น ครอบคลุมทุกทางที่เปลี่ยนสถานะได้ ทั้งการแก้ไขข้อมูลงาน " +
      "การเปลี่ยนสถานะโดยตรง และการเปลี่ยนสถานะพร้อมวันกำหนดเสร็จ/หมายเหตุ",
    TaskApprovalChanged:
      "ยิงเมื่อสถานะการอนุมัติของ 'ทั้งงาน' เปลี่ยน ได้แก่ ส่งเรื่องขออนุมัติ (Open), " +
      "ทุกคนอนุมัติครบแล้ว (Finished), มีคนปฏิเสธ (Rejected), ยกเลิกการขออนุมัติ (Cancel) " +
      "รวมถึงกรณีลบผู้อนุมัติคนที่ค้างอยู่คนสุดท้ายจนสายอนุมัติเสร็จ",
    TaskApproveStep:
      "ยิงทุกครั้งที่ผู้อนุมัติ 'แต่ละคน' ทำรายการ คือ อนุมัติ (Approved), ปฏิเสธ (Rejected) " +
      "และเรียกคืนการอนุมัติ (Recalled) — 1 ครั้งต่อ 1 คนที่ทำรายการ ไม่ใช่ครั้งเดียวต่อทั้งสายอนุมัติ",
  };

  static GetHookEventInfo = (hookEvent: string | null | undefined): string =>
    (hookEvent ? Utils.HookEventInfo[hookEvent] : "") ?? "";

  static GetAvaliableHookField = (hookEvent: HookEvents | null): string[] => {
    if (hookEvent == null) return [];
    switch (hookEvent) {
      // The two original events predate the view and still use the old PascalCase names. Leave them
      // alone: hooks already configured against them would silently resolve to "" if renamed.
      case HookEvents.ChangeTaskStatus:
      case HookEvents.ChangeTaskStatusByHuman:
        return ["UserId", "ExtUserId", "TaskId", "StatusOld", "StatusNew", "TaskName", "UserName"];

      // The four task events below draw their fields from vw_hookdata_taskinfo, plus the actor and
      // whatever before/after values only the event itself knows.
      case HookEvents.TaskInfoChange:
        return [...Utils.HookActorFields, ...Utils.HookTaskViewFields];
      case HookEvents.TaskStatusChanged:
        return [...Utils.HookActorFields, "statusOld", "statusNew", ...Utils.HookTaskViewFields];
      case HookEvents.TaskApprovalChanged:
        return [...Utils.HookActorFields, "approveStatusOld", "approveStatusNew", ...Utils.HookTaskViewFields];
      case HookEvents.TaskApproveStep:
        // stepSeq/stepAction/stepRemark are sent as "extra" by TkApproveStep, TkRejectStep and
        // TkRecallStep - they describe the one step that was just acted on.
        return [...Utils.HookActorFields, "stepSeq", "stepAction", "stepRemark", ...Utils.HookTaskViewFields];

      default:
        return [];
    }
  }

  /** Events that carry extra filter criteria (stored as JSON in tb_hook.jsonfilter). */
  static HookEventsWithFilter: HookEvents[] = [
    HookEvents.TaskInfoChange,
    HookEvents.TaskStatusChanged,
    HookEvents.TaskApprovalChanged,
    HookEvents.TaskApproveStep,
  ];

  static HookEventHasFilter = (hookEvent: HookEvents | string | null | undefined): boolean => {
    if (!hookEvent) return false;
    return Utils.HookEventsWithFilter.includes(hookEvent as HookEvents);
  }

  static ParseHookFilterData = (json: string | null | undefined): HookFilterData => {
    if (!json) return {};
    try {
      return (JSON.parse(json) as HookFilterData) ?? {};
    } catch {
      return {};
    }
  }

  /**
   * Builds {"docType":"A,B,C","includeBot":true,"autoDescription":false}. Every key is always
   * written so the backend never has to check for a missing one. Returns null when nothing is set
   * at all, so tb_hook.jsonfilter stays NULL instead of holding a no-op object.
   */
  static BuildHookFilterData = (filter: HookFilterData): string | null => {
    const docType = (filter.docType ?? "").trim();
    const includeBot = filter.includeBot === true;
    const autoDescription = filter.autoDescription === true;
    if (!docType && !includeBot && !autoDescription) return null;
    return JSON.stringify({ docType: docType, includeBot: includeBot, autoDescription: autoDescription });
  }

  /**
   * e.g. "Task Info Change on PR,PO include by bot" / "Task Info Change all doctype not include by bot".
   * Events that carry no extra parameters are described by their name alone, e.g. "Change Task Status".
   */
  static BuildHookAutoDescription = (hookEvent: HookEvents | string | null | undefined, filter: HookFilterData): string => {
    if (!hookEvent) return "";
    const name = Utils.SplitByCase(hookEvent as string);
    if (!Utils.HookEventHasFilter(hookEvent)) return name;

    const docType = (filter.docType ?? "").trim();
    return [
      name,
      docType ? `on ${docType}` : "all doctype",
      filter.includeBot === true ? "include by bot" : "not include by bot",
    ].join(" ");
  }
}

class TestClass {
  static Alert = (value: any) => {
    alert(value);
  }
}

class CurUser {
  static SaveToLocal = (authUserJson: string | null, jwtToken: string | null) => {
    if (authUserJson != null && authUserJson != "") {
      localStorage.setItem("authUser", authUserJson);
      localStorage.setItem("authu2", authUserJson);
    }
    if (jwtToken != null && jwtToken != "") {
      Utils.JwtTokenSet(jwtToken);
    }
  }

  static ClearFromLocal = async (callFrom: string, clearReason: string) => {
    const keys = Utils.GetAllLocalStorageKey();
    const exist = localStorage.getItem("authUser") || Utils.JwtTokenGet();
    localStorage.removeItem("authUser");
    localStorage.removeItem("authu2");
    Utils.JwtTokenSet(null);
    try {
      // alert(`clear from local start from ${callFrom}, reason = ${clearReason}`);
      // if (exist) {
      await Utils.LogDb(`CearFromLocal: ${clearReason}, key = [${keys}]`, 1, callFrom, Utils.GetDeviceId());
      // }
    } catch (er) {
      // alert('clear from local error');
      console.error(er);
    }
  }

  static GetAuthUserFromLocal = (): string | null => {
    const a1 = localStorage.getItem("authUser");
    if (a1) return a1;
    const a2 = localStorage.getItem("authu2");
    return a2;
  }



}


export { Utils, LogDb, CurUser };